(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $3183cf6be595f421$exports = {};
function $81c9c858187986cb$export$71511d61b312f219(o) {
    $81c9c858187986cb$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $81c9c858187986cb$export$71511d61b312f219(o);
}


function $6f4699ca644cfb51$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($6f4699ca644cfb51$export$71511d61b312f219 = function() {
        return !!result;
    })();
}


function $981cfaf5c821609e$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $f4bb2077aa61b74c$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


function $2d772972bd4fe337$export$71511d61b312f219(self, call) {
    if (call && ((0, $f4bb2077aa61b74c$export$71511d61b312f219)(call) === "object" || typeof call === "function")) return call;
    return (0, $981cfaf5c821609e$export$71511d61b312f219)(self);
}


function $972025e4d4e45634$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $81c9c858187986cb$export$71511d61b312f219)(derived);
    return (0, $2d772972bd4fe337$export$71511d61b312f219)(_this, (0, $6f4699ca644cfb51$export$71511d61b312f219)() ? Reflect.construct(derived, args || [], (0, $81c9c858187986cb$export$71511d61b312f219)(_this).constructor) : derived.apply(_this, args));
}


function $369e92947825c2b5$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $11b219ef186b1c94$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $11b219ef186b1c94$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $11b219ef186b1c94$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $11b219ef186b1c94$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $28557b013f37bb6b$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



function $7096b25b59c4b2c1$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $81c9c858187986cb$export$71511d61b312f219)(object);
        if (object === null) break;
    }
    return object;
}


function $00e9f136d8b86c33$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $00e9f136d8b86c33$export$71511d61b312f219 = Reflect.get;
    else $00e9f136d8b86c33$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $7096b25b59c4b2c1$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $00e9f136d8b86c33$export$71511d61b312f219(target, property, receiver || target);
}



function $eda2aabf2c4b7bd6$export$71511d61b312f219(o, p) {
    $eda2aabf2c4b7bd6$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $eda2aabf2c4b7bd6$export$71511d61b312f219(o, p);
}


function $99c2e1b2c4a01e52$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $eda2aabf2c4b7bd6$export$71511d61b312f219)(subClass, superClass);
}



function $9bf4d105a019f48b$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $28557b013f37bb6b$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $92079f442e5d1061$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $92079f442e5d1061$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $92079f442e5d1061$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



function $cb24915816a1cfc9$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $b5cdf895c6f08ea2$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a4a4e8541bb818da$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $09e2f1f84ceddf09$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $0ee6bdd820e270f4$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $09e2f1f84ceddf09$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $09e2f1f84ceddf09$export$71511d61b312f219)(o, minLen);
}


function $91a007218046315e$export$71511d61b312f219(arr, i) {
    return (0, $cb24915816a1cfc9$export$71511d61b312f219)(arr) || (0, $b5cdf895c6f08ea2$export$71511d61b312f219)(arr, i) || (0, $0ee6bdd820e270f4$export$71511d61b312f219)(arr, i) || (0, $a4a4e8541bb818da$export$71511d61b312f219)();
}



function $1e5b70c2c2307a84$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $09e2f1f84ceddf09$export$71511d61b312f219)(arr);
}


function $9b1241b318447a2a$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $e0c9573dc9b3384a$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $8d1416c8f734345e$export$71511d61b312f219(arr) {
    return (0, $1e5b70c2c2307a84$export$71511d61b312f219)(arr) || (0, $9b1241b318447a2a$export$71511d61b312f219)(arr) || (0, $0ee6bdd820e270f4$export$71511d61b312f219)(arr) || (0, $e0c9573dc9b3384a$export$71511d61b312f219)();
}



/*!
  * Bootstrap v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $3183cf6be595f421$exports = factory();
})(undefined, function() {
    'use strict';
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/data.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var elementMap = new Map();
    var Data = {
        set: function(element, key, instance) {
            if (!elementMap.has(element)) elementMap.set(element, new Map());
            var instanceMap = elementMap.get(element);
            // make it clear we only want one instance per element
            // can be removed later when multiple key/instances are fine to be used
            if (!instanceMap.has(key) && instanceMap.size !== 0) {
                // eslint-disable-next-line no-console
                console.error("Bootstrap doesn't allow more than one instance per element. Bound instance: ".concat(Array.from(instanceMap.keys())[0], "."));
                return;
            }
            instanceMap.set(key, instance);
        },
        get: function(element, key) {
            if (elementMap.has(element)) return elementMap.get(element).get(key) || null;
            return null;
        },
        remove: function(element, key) {
            if (!elementMap.has(element)) return;
            var instanceMap = elementMap.get(element);
            instanceMap.delete(key);
            // free up element references if there are no instances left for an element
            if (instanceMap.size === 0) elementMap.delete(element);
        }
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ var MAX_UID = 1000000;
    var MILLISECONDS_MULTIPLIER = 1000;
    var TRANSITION_END = 'transitionend';
    /**
   * Properly escape IDs selectors to handle weird IDs
   * @param {string} selector
   * @returns {string}
   */ var parseSelector = function(selector) {
        if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
        selector = selector.replace(/#([^\s"#']+)/g, function(match, id) {
            return "#".concat(CSS.escape(id));
        });
        return selector;
    };
    // Shout-out Angus Croll (https://goo.gl/pxwQGp)
    var toType = function(object) {
        if (object === null || object === undefined) return "".concat(object);
        return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
    };
    /**
   * Public Util API
   */ var getUID = function(prefix) {
        do prefix += Math.floor(Math.random() * MAX_UID);
        while (document.getElementById(prefix));
        return prefix;
    };
    var getTransitionDurationFromElement = function(element) {
        if (!element) return 0;
        // Get transition-duration of the element
        var _window_getComputedStyle = window.getComputedStyle(element), transitionDuration = _window_getComputedStyle.transitionDuration, transitionDelay = _window_getComputedStyle.transitionDelay;
        var floatTransitionDuration = Number.parseFloat(transitionDuration);
        var floatTransitionDelay = Number.parseFloat(transitionDelay);
        // Return 0 if element or transition duration is not found
        if (!floatTransitionDuration && !floatTransitionDelay) return 0;
        // If multiple durations are defined, take the first
        transitionDuration = transitionDuration.split(',')[0];
        transitionDelay = transitionDelay.split(',')[0];
        return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
    };
    var triggerTransitionEnd = function(element) {
        element.dispatchEvent(new Event(TRANSITION_END));
    };
    var isElement$1 = function(object) {
        if (!object || (typeof object === "undefined" ? "undefined" : (0, $f4bb2077aa61b74c$export$71511d61b312f219)(object)) !== 'object') return false;
        if (typeof object.jquery !== 'undefined') object = object[0];
        return typeof object.nodeType !== 'undefined';
    };
    var getElement = function(object) {
        // it's a jQuery object or a node element
        if (isElement$1(object)) return object.jquery ? object[0] : object;
        if (typeof object === 'string' && object.length > 0) return document.querySelector(parseSelector(object));
        return null;
    };
    var isVisible = function(element) {
        if (!isElement$1(element) || element.getClientRects().length === 0) return false;
        var elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
        // Handle `details` element as its content may falsie appear visible when it is closed
        var closedDetails = element.closest('details:not([open])');
        if (!closedDetails) return elementIsVisible;
        if (closedDetails !== element) {
            var summary = element.closest('summary');
            if (summary && summary.parentNode !== closedDetails) return false;
            if (summary === null) return false;
        }
        return elementIsVisible;
    };
    var isDisabled = function(element) {
        if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
        if (element.classList.contains('disabled')) return true;
        if (typeof element.disabled !== 'undefined') return element.disabled;
        return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
    };
    var findShadowRoot = function(element) {
        if (!document.documentElement.attachShadow) return null;
        // Can find the shadow root otherwise it'll return the document
        if (typeof element.getRootNode === 'function') {
            var root = element.getRootNode();
            return root instanceof ShadowRoot ? root : null;
        }
        if (element instanceof ShadowRoot) return element;
        // when we don't find a shadow root
        if (!element.parentNode) return null;
        return findShadowRoot(element.parentNode);
    };
    var noop = function() {};
    /**
   * Trick to restart an element's animation
   *
   * @param {HTMLElement} element
   * @return void
   *
   * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
   */ var reflow = function(element) {
        element.offsetHeight; // eslint-disable-line no-unused-expressions
    };
    var getjQuery = function() {
        if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
        return null;
    };
    var DOMContentLoadedCallbacks = [];
    var onDOMContentLoaded = function(callback) {
        if (document.readyState === 'loading') {
            // add listener on the first call when the document is in loading state
            if (!DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', function() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = DOMContentLoadedCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$callback = _step.value;
                        _$callback();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
            DOMContentLoadedCallbacks.push(callback);
        } else callback();
    };
    var isRTL = function() {
        return document.documentElement.dir === 'rtl';
    };
    var defineJQueryPlugin = function(plugin) {
        onDOMContentLoaded(function() {
            var $ = getjQuery();
            /* istanbul ignore if */ if ($) {
                var name = plugin.NAME;
                var JQUERY_NO_CONFLICT = $.fn[name];
                $.fn[name] = plugin.jQueryInterface;
                $.fn[name].Constructor = plugin;
                $.fn[name].noConflict = function() {
                    $.fn[name] = JQUERY_NO_CONFLICT;
                    return plugin.jQueryInterface;
                };
            }
        });
    };
    var execute = function(possibleCallback) {
        var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : possibleCallback;
        var _possibleCallback;
        return typeof possibleCallback === 'function' ? (_possibleCallback = possibleCallback).call.apply(_possibleCallback, (0, $8d1416c8f734345e$export$71511d61b312f219)(args)) : defaultValue;
    };
    var executeAfterTransition = function(callback, transitionElement) {
        var waitForTransition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        if (!waitForTransition) {
            execute(callback);
            return;
        }
        var durationPadding = 5;
        var emulatedDuration = getTransitionDurationFromElement(transitionElement) + durationPadding;
        var called = false;
        var handler = function(param) {
            var target = param.target;
            if (target !== transitionElement) return;
            called = true;
            transitionElement.removeEventListener(TRANSITION_END, handler);
            execute(callback);
        };
        transitionElement.addEventListener(TRANSITION_END, handler);
        setTimeout(function() {
            if (!called) triggerTransitionEnd(transitionElement);
        }, emulatedDuration);
    };
    /**
   * Return the previous/next element of a list.
   *
   * @param {array} list    The list of elements
   * @param activeElement   The active element
   * @param shouldGetNext   Choose to get next or previous element
   * @param isCycleAllowed
   * @return {Element|elem} The proper element
   */ var getNextActiveElement = function(list, activeElement, shouldGetNext, isCycleAllowed) {
        var listLength = list.length;
        var index = list.indexOf(activeElement);
        // if the element does not exist in the list return an element
        // depending on the direction and if cycle is allowed
        if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
        index += shouldGetNext ? 1 : -1;
        if (isCycleAllowed) index = (index + listLength) % listLength;
        return list[Math.max(0, Math.min(index, listLength - 1))];
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/event-handler.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var namespaceRegex = /[^.]*(?=\..*)\.|.*/;
    var stripNameRegex = /\..*/;
    var stripUidRegex = /::\d+$/;
    var eventRegistry = {}; // Events storage
    var uidEvent = 1;
    var customEvents = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout'
    };
    var nativeEvents = new Set([
        'click',
        'dblclick',
        'mouseup',
        'mousedown',
        'contextmenu',
        'mousewheel',
        'DOMMouseScroll',
        'mouseover',
        'mouseout',
        'mousemove',
        'selectstart',
        'selectend',
        'keydown',
        'keypress',
        'keyup',
        'orientationchange',
        'touchstart',
        'touchmove',
        'touchend',
        'touchcancel',
        'pointerdown',
        'pointermove',
        'pointerup',
        'pointerleave',
        'pointercancel',
        'gesturestart',
        'gesturechange',
        'gestureend',
        'focus',
        'blur',
        'change',
        'reset',
        'select',
        'submit',
        'focusin',
        'focusout',
        'load',
        'unload',
        'beforeunload',
        'resize',
        'move',
        'DOMContentLoaded',
        'readystatechange',
        'error',
        'abort',
        'scroll'
    ]);
    /**
   * Private methods
   */ function makeEventUid(element, uid) {
        return uid && "".concat(uid, "::").concat(uidEvent++) || element.uidEvent || uidEvent++;
    }
    function getElementEvents(element) {
        var uid = makeEventUid(element);
        element.uidEvent = uid;
        eventRegistry[uid] = eventRegistry[uid] || {};
        return eventRegistry[uid];
    }
    function bootstrapHandler(element, fn) {
        return function handler(event) {
            hydrateObj(event, {
                delegateTarget: element
            });
            if (handler.oneOff) EventHandler.off(element, event.type, fn);
            return fn.apply(element, [
                event
            ]);
        };
    }
    function bootstrapDelegationHandler(element, selector, fn) {
        return function handler(event) {
            var domElements = element.querySelectorAll(selector);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            for(var target = event.target; target && target !== this; target = target.parentNode)try {
                for(var _iterator = domElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var domElement = _step.value;
                    if (domElement !== target) continue;
                    hydrateObj(event, {
                        delegateTarget: target
                    });
                    if (handler.oneOff) EventHandler.off(element, event.type, selector, fn);
                    return fn.apply(target, [
                        event
                    ]);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
    }
    function findHandler(events, callable) {
        var delegationSelector = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        return Object.values(events).find(function(event) {
            return event.callable === callable && event.delegationSelector === delegationSelector;
        });
    }
    function normalizeParameters(originalTypeEvent, handler, delegationFunction) {
        var isDelegated = typeof handler === 'string';
        // TODO: tooltip passes `false` instead of selector, so we need to check
        var callable = isDelegated ? delegationFunction : handler || delegationFunction;
        var typeEvent = getTypeEvent(originalTypeEvent);
        if (!nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
        return [
            isDelegated,
            callable,
            typeEvent
        ];
    }
    function addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        var _normalizeParameters = (0, $91a007218046315e$export$71511d61b312f219)(normalizeParameters(originalTypeEvent, handler, delegationFunction), 3), isDelegated = _normalizeParameters[0], callable = _normalizeParameters[1], typeEvent = _normalizeParameters[2];
        // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
        // this prevents the handler from being dispatched the same way as mouseover or mouseout does
        if (originalTypeEvent in customEvents) {
            var wrapFunction = function(fn) {
                return function wrapFunction(event) {
                    if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
                };
            };
            callable = wrapFunction(callable);
        }
        var events = getElementEvents(element);
        var handlers = events[typeEvent] || (events[typeEvent] = {});
        var previousFunction = findHandler(handlers, callable, isDelegated ? handler : null);
        if (previousFunction) {
            previousFunction.oneOff = previousFunction.oneOff && oneOff;
            return;
        }
        var uid = makeEventUid(callable, originalTypeEvent.replace(namespaceRegex, ''));
        var fn = isDelegated ? bootstrapDelegationHandler(element, handler, callable) : bootstrapHandler(element, callable);
        fn.delegationSelector = isDelegated ? handler : null;
        fn.callable = callable;
        fn.oneOff = oneOff;
        fn.uidEvent = uid;
        handlers[uid] = fn;
        element.addEventListener(typeEvent, fn, isDelegated);
    }
    function removeHandler(element, events, typeEvent, handler, delegationSelector) {
        var fn = findHandler(events[typeEvent], handler, delegationSelector);
        if (!fn) return;
        element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
        delete events[typeEvent][fn.uidEvent];
    }
    function removeNamespacedHandlers(element, events, typeEvent, namespace) {
        var storeElementEvent = events[typeEvent] || {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(storeElementEvent)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $91a007218046315e$export$71511d61b312f219)(_step.value, 2), handlerKey = _step_value[0], event = _step_value[1];
                if (handlerKey.includes(namespace)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function getTypeEvent(event) {
        // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
        event = event.replace(stripNameRegex, '');
        return customEvents[event] || event;
    }
    var EventHandler = {
        on: function(element, event, handler, delegationFunction) {
            addHandler(element, event, handler, delegationFunction, false);
        },
        one: function(element, event, handler, delegationFunction) {
            addHandler(element, event, handler, delegationFunction, true);
        },
        off: function(element, originalTypeEvent, handler, delegationFunction) {
            if (typeof originalTypeEvent !== 'string' || !element) return;
            var _normalizeParameters = (0, $91a007218046315e$export$71511d61b312f219)(normalizeParameters(originalTypeEvent, handler, delegationFunction), 3), isDelegated = _normalizeParameters[0], callable = _normalizeParameters[1], typeEvent = _normalizeParameters[2];
            var inNamespace = typeEvent !== originalTypeEvent;
            var events = getElementEvents(element);
            var storeElementEvent = events[typeEvent] || {};
            var isNamespace = originalTypeEvent.startsWith('.');
            if (typeof callable !== 'undefined') {
                // Simplest case: handler is passed, remove that listener ONLY.
                if (!Object.keys(storeElementEvent).length) return;
                removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
                return;
            }
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (isNamespace) try {
                for(var _iterator = Object.keys(events)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var elementEvent = _step.value;
                    removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = Object.entries(storeElementEvent)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _step_value = (0, $91a007218046315e$export$71511d61b312f219)(_step1.value, 2), keyHandlers = _step_value[0], event = _step_value[1];
                    var handlerKey = keyHandlers.replace(stripUidRegex, '');
                    if (!inNamespace || originalTypeEvent.includes(handlerKey)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        },
        trigger: function(element, event, args) {
            if (typeof event !== 'string' || !element) return null;
            var $ = getjQuery();
            var typeEvent = getTypeEvent(event);
            var inNamespace = event !== typeEvent;
            var jQueryEvent = null;
            var bubbles = true;
            var nativeDispatch = true;
            var defaultPrevented = false;
            if (inNamespace && $) {
                jQueryEvent = $.Event(event, args);
                $(element).trigger(jQueryEvent);
                bubbles = !jQueryEvent.isPropagationStopped();
                nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
                defaultPrevented = jQueryEvent.isDefaultPrevented();
            }
            var evt = hydrateObj(new Event(event, {
                bubbles: bubbles,
                cancelable: true
            }), args);
            if (defaultPrevented) evt.preventDefault();
            if (nativeDispatch) element.dispatchEvent(evt);
            if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
            return evt;
        }
    };
    function hydrateObj(obj) {
        var meta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var _step_value = (0, $91a007218046315e$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                try {
                    obj[key] = value;
                } catch (_unused) {
                    Object.defineProperty(obj, key, {
                        configurable: true,
                        get: function() {
                            return value;
                        }
                    });
                }
            };
            for(var _iterator = Object.entries(meta)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return obj;
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/manipulator.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ function normalizeData(value) {
        if (value === 'true') return true;
        if (value === 'false') return false;
        if (value === Number(value).toString()) return Number(value);
        if (value === '' || value === 'null') return null;
        if (typeof value !== 'string') return value;
        try {
            return JSON.parse(decodeURIComponent(value));
        } catch (_unused) {
            return value;
        }
    }
    function normalizeDataKey(key) {
        return key.replace(/[A-Z]/g, function(chr) {
            return "-".concat(chr.toLowerCase());
        });
    }
    var Manipulator = {
        setDataAttribute: function(element, key, value) {
            element.setAttribute("data-bs-".concat(normalizeDataKey(key)), value);
        },
        removeDataAttribute: function(element, key) {
            element.removeAttribute("data-bs-".concat(normalizeDataKey(key)));
        },
        getDataAttributes: function(element) {
            if (!element) return {};
            var attributes = {};
            var bsKeys = Object.keys(element.dataset).filter(function(key) {
                return key.startsWith('bs') && !key.startsWith('bsConfig');
            });
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = bsKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var key = _step.value;
                    var pureKey = key.replace(/^bs/, '');
                    pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
                    attributes[pureKey] = normalizeData(element.dataset[key]);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return attributes;
        },
        getDataAttribute: function(element, key) {
            return normalizeData(element.getAttribute("data-bs-".concat(normalizeDataKey(key))));
        }
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/config.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Class definition
   */ var Config = /*#__PURE__*/ function() {
        function Config() {
            (0, $369e92947825c2b5$export$71511d61b312f219)(this, Config);
        }
        (0, $11b219ef186b1c94$export$71511d61b312f219)(Config, [
            {
                key: "_getConfig",
                value: function _getConfig(config) {
                    config = this._mergeConfigObj(config);
                    config = this._configAfterMerge(config);
                    this._typeCheckConfig(config);
                    return config;
                }
            },
            {
                key: "_configAfterMerge",
                value: function _configAfterMerge(config) {
                    return config;
                }
            },
            {
                key: "_mergeConfigObj",
                value: function _mergeConfigObj(config, element) {
                    var jsonConfig = isElement$1(element) ? Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
                    return (0, $9bf4d105a019f48b$export$71511d61b312f219)({}, this.constructor.Default, (typeof jsonConfig === "undefined" ? "undefined" : (0, $f4bb2077aa61b74c$export$71511d61b312f219)(jsonConfig)) === 'object' ? jsonConfig : {}, isElement$1(element) ? Manipulator.getDataAttributes(element) : {}, (typeof config === "undefined" ? "undefined" : (0, $f4bb2077aa61b74c$export$71511d61b312f219)(config)) === 'object' ? config : {});
                }
            },
            {
                key: "_typeCheckConfig",
                value: function _typeCheckConfig(config) {
                    var configTypes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.constructor.DefaultType;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(configTypes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $91a007218046315e$export$71511d61b312f219)(_step.value, 2), property = _step_value[0], expectedTypes = _step_value[1];
                            var value = config[property];
                            var valueType = isElement$1(value) ? 'element' : toType(value);
                            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError("".concat(this.constructor.NAME.toUpperCase(), ': Option "').concat(property, '" provided type "').concat(valueType, '" but expected type "').concat(expectedTypes, '".'));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        ], [
            {
                key: "Default",
                get: // Getters
                function get() {
                    return {};
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return {};
                }
            },
            {
                key: "NAME",
                get: function get() {
                    throw new Error('You have to implement the static method "NAME", for each component!');
                }
            }
        ]);
        return Config;
    }();
    /**
   * --------------------------------------------------------------------------
   * Bootstrap base-component.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var VERSION = '5.3.8';
    /**
   * Class definition
   */ var BaseComponent = /*#__PURE__*/ function(Config) {
        (0, $99c2e1b2c4a01e52$export$71511d61b312f219)(BaseComponent, Config);
        function BaseComponent(element, config) {
            (0, $369e92947825c2b5$export$71511d61b312f219)(this, BaseComponent);
            var _this;
            _this = (0, $972025e4d4e45634$export$71511d61b312f219)(this, BaseComponent);
            element = getElement(element);
            if (!element) return (0, $2d772972bd4fe337$export$71511d61b312f219)(_this);
            _this._element = element;
            _this._config = _this._getConfig(config);
            Data.set(_this._element, _this.constructor.DATA_KEY, _this);
            return _this;
        }
        (0, $11b219ef186b1c94$export$71511d61b312f219)(BaseComponent, [
            {
                // Public
                key: "dispose",
                value: function dispose() {
                    Data.remove(this._element, this.constructor.DATA_KEY);
                    EventHandler.off(this._element, this.constructor.EVENT_KEY);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.getOwnPropertyNames(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var propertyName = _step.value;
                            this[propertyName] = null;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                // Private
                key: "_queueCallback",
                value: function _queueCallback(callback, element) {
                    var isAnimated = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                    executeAfterTransition(callback, element, isAnimated);
                }
            },
            {
                key: "_getConfig",
                value: function _getConfig(config) {
                    config = this._mergeConfigObj(config, this._element);
                    config = this._configAfterMerge(config);
                    this._typeCheckConfig(config);
                    return config;
                }
            }
        ], [
            {
                key: "getInstance",
                value: // Static
                function getInstance(element) {
                    return Data.get(getElement(element), this.DATA_KEY);
                }
            },
            {
                key: "getOrCreateInstance",
                value: function getOrCreateInstance(element) {
                    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    return this.getInstance(element) || new this(element, (typeof config === "undefined" ? "undefined" : (0, $f4bb2077aa61b74c$export$71511d61b312f219)(config)) === 'object' ? config : null);
                }
            },
            {
                key: "VERSION",
                get: function get() {
                    return VERSION;
                }
            },
            {
                key: "DATA_KEY",
                get: function get() {
                    return "bs.".concat(this.NAME);
                }
            },
            {
                key: "EVENT_KEY",
                get: function get() {
                    return ".".concat(this.DATA_KEY);
                }
            },
            {
                key: "eventName",
                value: function eventName(name) {
                    return "".concat(name).concat(this.EVENT_KEY);
                }
            }
        ]);
        return BaseComponent;
    }(Config);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/selector-engine.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ var getSelector = function(element) {
        var selector = element.getAttribute('data-bs-target');
        if (!selector || selector === '#') {
            var hrefAttribute = element.getAttribute('href');
            // The only valid content that could double as a selector are IDs or classes,
            // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
            // `document.querySelector` will rightfully complain it is invalid.
            // See https://github.com/twbs/bootstrap/issues/32273
            if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
            // Just in case some CMS puts out a full URL with the anchor appended
            if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = "#".concat(hrefAttribute.split('#')[1]);
            selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
        }
        return selector ? selector.split(',').map(function(sel) {
            return parseSelector(sel);
        }).join(',') : null;
    };
    var SelectorEngine = {
        find: function(selector) {
            var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement;
            var _instance;
            return (_instance = []).concat.apply(_instance, (0, $8d1416c8f734345e$export$71511d61b312f219)(Element.prototype.querySelectorAll.call(element, selector)));
        },
        findOne: function(selector) {
            var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement;
            return Element.prototype.querySelector.call(element, selector);
        },
        children: function(element, selector) {
            var _instance;
            return (_instance = []).concat.apply(_instance, (0, $8d1416c8f734345e$export$71511d61b312f219)(element.children)).filter(function(child) {
                return child.matches(selector);
            });
        },
        parents: function(element, selector) {
            var parents = [];
            var ancestor = element.parentNode.closest(selector);
            while(ancestor){
                parents.push(ancestor);
                ancestor = ancestor.parentNode.closest(selector);
            }
            return parents;
        },
        prev: function(element, selector) {
            var previous = element.previousElementSibling;
            while(previous){
                if (previous.matches(selector)) return [
                    previous
                ];
                previous = previous.previousElementSibling;
            }
            return [];
        },
        // TODO: this is now unused; remove later along with prev()
        next: function(element, selector) {
            var next = element.nextElementSibling;
            while(next){
                if (next.matches(selector)) return [
                    next
                ];
                next = next.nextElementSibling;
            }
            return [];
        },
        focusableChildren: function(element) {
            var focusables = [
                'a',
                'button',
                'input',
                'textarea',
                'select',
                'details',
                '[tabindex]',
                '[contenteditable="true"]'
            ].map(function(selector) {
                return "".concat(selector, ':not([tabindex^="-"])');
            }).join(',');
            return this.find(focusables, element).filter(function(el) {
                return !isDisabled(el) && isVisible(el);
            });
        },
        getSelectorFromElement: function(element) {
            var selector = getSelector(element);
            if (selector) return SelectorEngine.findOne(selector) ? selector : null;
            return null;
        },
        getElementFromSelector: function(element) {
            var selector = getSelector(element);
            return selector ? SelectorEngine.findOne(selector) : null;
        },
        getMultipleElementsFromSelector: function(element) {
            var selector = getSelector(element);
            return selector ? SelectorEngine.find(selector) : [];
        }
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/component-functions.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ var enableDismissTrigger = function(component) {
        var method = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'hide';
        var clickEvent = "click.dismiss".concat(component.EVENT_KEY);
        var name = component.NAME;
        EventHandler.on(document, clickEvent, '[data-bs-dismiss="'.concat(name, '"]'), function(event) {
            if ([
                'A',
                'AREA'
            ].includes(this.tagName)) event.preventDefault();
            if (isDisabled(this)) return;
            var target = SelectorEngine.getElementFromSelector(this) || this.closest(".".concat(name));
            var instance = component.getOrCreateInstance(target);
            // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
            instance[method]();
        });
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap alert.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var NAME$f = 'alert';
    var DATA_KEY$a = 'bs.alert';
    var EVENT_KEY$b = ".".concat(DATA_KEY$a);
    var EVENT_CLOSE = "close".concat(EVENT_KEY$b);
    var EVENT_CLOSED = "closed".concat(EVENT_KEY$b);
    var CLASS_NAME_FADE$5 = 'fade';
    var CLASS_NAME_SHOW$8 = 'show';
    /**
   * Class definition
   */ var Alert = /*#__PURE__*/ function(BaseComponent) {
        (0, $99c2e1b2c4a01e52$export$71511d61b312f219)(Alert, BaseComponent);
        function Alert() {
            (0, $369e92947825c2b5$export$71511d61b312f219)(this, Alert);
            return (0, $972025e4d4e45634$export$71511d61b312f219)(this, Alert, arguments);
        }
        (0, $11b219ef186b1c94$export$71511d61b312f219)(Alert, [
            {
                // Public
                key: "close",
                value: function close() {
                    var _this = this;
                    var closeEvent = EventHandler.trigger(this._element, EVENT_CLOSE);
                    if (closeEvent.defaultPrevented) return;
                    this._element.classList.remove(CLASS_NAME_SHOW$8);
                    var isAnimated = this._element.classList.contains(CLASS_NAME_FADE$5);
                    this._queueCallback(function() {
                        return _this._destroyElement();
                    }, this._element, isAnimated);
                }
            },
            {
                // Private
                key: "_destroyElement",
                value: function _destroyElement() {
                    this._element.remove();
                    EventHandler.trigger(this._element, EVENT_CLOSED);
                    this.dispose();
                }
            }
        ], [
            {
                key: "NAME",
                get: // Getters
                function get() {
                    return NAME$f;
                }
            },
            {
                key: "jQueryInterface",
                value: // Static
                function jQueryInterface(config) {
                    return this.each(function() {
                        var data = Alert.getOrCreateInstance(this);
                        if (typeof config !== 'string') return;
                        if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config](this);
                    });
                }
            }
        ]);
        return Alert;
    }(BaseComponent);
    /**
   * Data API implementation
   */ enableDismissTrigger(Alert, 'close');
    /**
   * jQuery
   */ defineJQueryPlugin(Alert);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap button.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var NAME$e = 'button';
    var DATA_KEY$9 = 'bs.button';
    var EVENT_KEY$a = ".".concat(DATA_KEY$9);
    var DATA_API_KEY$6 = '.data-api';
    var CLASS_NAME_ACTIVE$3 = 'active';
    var SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
    var EVENT_CLICK_DATA_API$6 = "click".concat(EVENT_KEY$a).concat(DATA_API_KEY$6);
    /**
   * Class definition
   */ var Button = /*#__PURE__*/ function(BaseComponent) {
        (0, $99c2e1b2c4a01e52$export$71511d61b312f219)(Button, BaseComponent);
        function Button() {
            (0, $369e92947825c2b5$export$71511d61b312f219)(this, Button);
            return (0, $972025e4d4e45634$export$71511d61b312f219)(this, Button, arguments);
        }
        (0, $11b219ef186b1c94$export$71511d61b312f219)(Button, [
            {
                // Public
                key: "toggle",
                value: function toggle() {
                    // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
                    this._element.setAttribute('aria-pressed', this._element.classList.toggle(CLASS_NAME_ACTIVE$3));
                }
            }
        ], [
            {
                key: "NAME",
                get: // Getters
                function get() {
                    return NAME$e;
                }
            },
            {
                key: "jQueryInterface",
                value: // Static
                function jQueryInterface(config) {
                    return this.each(function() {
                        var data = Button.getOrCreateInstance(this);
                        if (config === 'toggle') data[config]();
                    });
                }
            }
        ]);
        return Button;
    }(BaseComponent);
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$6, SELECTOR_DATA_TOGGLE$5, function(event) {
        event.preventDefault();
        var button = event.target.closest(SELECTOR_DATA_TOGGLE$5);
        var data = Button.getOrCreateInstance(button);
        data.toggle();
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Button);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/swipe.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var NAME$d = 'swipe';
    var EVENT_KEY$9 = '.bs.swipe';
    var EVENT_TOUCHSTART = "touchstart".concat(EVENT_KEY$9);
    var EVENT_TOUCHMOVE = "touchmove".concat(EVENT_KEY$9);
    var EVENT_TOUCHEND = "touchend".concat(EVENT_KEY$9);
    var EVENT_POINTERDOWN = "pointerdown".concat(EVENT_KEY$9);
    var EVENT_POINTERUP = "pointerup".concat(EVENT_KEY$9);
    var POINTER_TYPE_TOUCH = 'touch';
    var POINTER_TYPE_PEN = 'pen';
    var CLASS_NAME_POINTER_EVENT = 'pointer-event';
    var SWIPE_THRESHOLD = 40;
    var Default$c = {
        endCallback: null,
        leftCallback: null,
        rightCallback: null
    };
    var DefaultType$c = {
        endCallback: '(function|null)',
        leftCallback: '(function|null)',
        rightCallback: '(function|null)'
    };
    /**
   * Class definition
   */ var Swipe = /*#__PURE__*/ function(Config) {
        (0, $99c2e1b2c4a01e52$export$71511d61b312f219)(Swipe, Config);
        function Swipe(element, config) {
            (0, $369e92947825c2b5$export$71511d61b312f219)(this, Swipe);
            var _this;
            _this = (0, $972025e4d4e45634$export$71511d61b312f219)(this, Swipe);
            _this._element = element;
            if (!element || !Swipe.isSupported()) return (0, $2d772972bd4fe337$export$71511d61b312f219)(_this);
            _this._config = _this._getConfig(config);
            _this._deltaX = 0;
            _this._supportPointerEvents = Boolean(window.PointerEvent);
            _this._initEvents();
            return _this;
        }
        (0, $11b219ef186b1c94$export$71511d61b312f219)(Swipe, [
            {
                // Public
                key: "dispose",
                value: function dispose() {
                    EventHandler.off(this._element, EVENT_KEY$9);
                }
            },
            {
                // Private
                key: "_start",
                value: function _start(event) {
                    if (!this._supportPointerEvents) {
                        this._deltaX = event.touches[0].clientX;
                        return;
                    }
                    if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
                }
            },
            {
                key: "_end",
                value: function _end(event) {
                    if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
                    this._handleSwipe();
                    execute(this._config.endCallback);
                }
            },
            {
                key: "_move",
                value: function _move(event) {
                    this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
                }
            },
            {
                key: "_handleSwipe",
                value: function _handleSwipe() {
                    var absDeltaX = Math.abs(this._deltaX);
                    if (absDeltaX <= SWIPE_THRESHOLD) return;
                    var direction = absDeltaX / this._deltaX;
                    this._deltaX = 0;
                    if (!direction) return;
                    execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
                }
            },
            {
                key: "_initEvents",
                value: function _initEvents() {
                    var _this = this;
                    if (this._supportPointerEvents) {
                        EventHandler.on(this._element, EVENT_POINTERDOWN, function(event) {
                            return _this._start(event);
                        });
                        EventHandler.on(this._element, EVENT_POINTERUP, function(event) {
                            return _this._end(event);
                        });
                        this._element.classList.add(CLASS_NAME_POINTER_EVENT);
                    } else {
                        EventHandler.on(this._element, EVENT_TOUCHSTART, function(event) {
                            return _this._start(event);
                        });
                        EventHandler.on(this._element, EVENT_TOUCHMOVE, function(event) {
                            return _this._move(event);
                        });
                        EventHandler.on(this._element, EVENT_TOUCHEND, function(event) {
                            return _this._end(event);
                        });
                    }
                }
            },
            {
                key: "_eventIsPointerPenTouch",
                value: function _eventIsPointerPenTouch(event) {
                    return this._supportPointerEvents && (event.pointerType === POINTER_TYPE_PEN || event.pointerType === POINTER_TYPE_TOUCH);
                }
            }
        ], [
            {
                key: "Default",
                get: // Getters
                function get() {
                    return Default$c;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$c;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$d;
                }
            },
            {
                key: "isSupported",
                value: // Static
                function isSupported() {
                    return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
                }
            }
        ]);
        return Swipe;
    }(Config);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap carousel.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var NAME$c = 'carousel';
    var DATA_KEY$8 = 'bs.carousel';
    var EVENT_KEY$8 = ".".concat(DATA_KEY$8);
    var DATA_API_KEY$5 = '.data-api';
    var ARROW_LEFT_KEY$1 = 'ArrowLeft';
    var ARROW_RIGHT_KEY$1 = 'ArrowRight';
    var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
    var ORDER_NEXT = 'next';
    var ORDER_PREV = 'prev';
    var DIRECTION_LEFT = 'left';
    var DIRECTION_RIGHT = 'right';
    var EVENT_SLIDE = "slide".concat(EVENT_KEY$8);
    var EVENT_SLID = "slid".concat(EVENT_KEY$8);
    var EVENT_KEYDOWN$1 = "keydown".concat(EVENT_KEY$8);
    var EVENT_MOUSEENTER$1 = "mouseenter".concat(EVENT_KEY$8);
    var EVENT_MOUSELEAVE$1 = "mouseleave".concat(EVENT_KEY$8);
    var EVENT_DRAG_START = "dragstart".concat(EVENT_KEY$8);
    var EVENT_LOAD_DATA_API$3 = "load".concat(EVENT_KEY$8).concat(DATA_API_KEY$5);
    var EVENT_CLICK_DATA_API$5 = "click".concat(EVENT_KEY$8).concat(DATA_API_KEY$5);
    var CLASS_NAME_CAROUSEL = 'carousel';
    var CLASS_NAME_ACTIVE$2 = 'active';
    var CLASS_NAME_SLIDE = 'slide';
    var CLASS_NAME_END = 'carousel-item-end';
    var CLASS_NAME_START = 'carousel-item-start';
    var CLASS_NAME_NEXT = 'carousel-item-next';
    var CLASS_NAME_PREV = 'carousel-item-prev';
    var SELECTOR_ACTIVE = '.active';
    var SELECTOR_ITEM = '.carousel-item';
    var SELECTOR_ACTIVE_ITEM = SELECTOR_ACTIVE + SELECTOR_ITEM;
    var SELECTOR_ITEM_IMG = '.carousel-item img';
    var SELECTOR_INDICATORS = '.carousel-indicators';
    var SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
    var SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
    var _obj;
    var KEY_TO_DIRECTION = (_obj = {}, (0, $28557b013f37bb6b$export$71511d61b312f219)(_obj, ARROW_LEFT_KEY$1, DIRECTION_RIGHT), (0, $28557b013f37bb6b$export$71511d61b312f219)(_obj, ARROW_RIGHT_KEY$1, DIRECTION_LEFT), _obj);
    var Default$b = {
        interval: 5000,
        keyboard: true,
        pause: 'hover',
        ride: false,
        touch: true,
        wrap: true
    };
    var DefaultType$b = {
        interval: '(number|boolean)',
        // TODO:v6 remove boolean support
        keyboard: 'boolean',
        pause: '(string|boolean)',
        ride: '(boolean|string)',
        touch: 'boolean',
        wrap: 'boolean'
    };
    /**
   * Class definition
   */ var Carousel = /*#__PURE__*/ function(BaseComponent) {
        (0, $99c2e1b2c4a01e52$export$71511d61b312f219)(Carousel, BaseComponent);
        function Carousel(element, config) {
            (0, $369e92947825c2b5$export$71511d61b312f219)(this, Carousel);
            var _this;
            _this = (0, $972025e4d4e45634$export$71511d61b312f219)(this, Carousel, [
                element,
                config
            ]);
            _this._interval = null;
            _this._activeElement = null;
            _this._isSliding = false;
            _this.touchTimeout = null;
            _this._swipeHelper = null;
            _this._indicatorsElement = SelectorEngine.findOne(SELECTOR_INDICATORS, _this._element);
            _this._addEventListeners();
            if (_this._config.ride === CLASS_NAME_CAROUSEL) _this.cycle();
            return _this;
        }
        (0, $11b219ef186b1c94$export$71511d61b312f219)(Carousel, [
            {
                // Public
                key: "next",
                value: function next() {
                    this._slide(ORDER_NEXT);
                }
            },
            {
                key: "nextWhenVisible",
                value: function nextWhenVisible() {
                    // FIXME TODO use `document.visibilityState`
                    // Don't call next when the page isn't visible
                    // or the carousel or its parent isn't visible
                    if (!document.hidden && isVisible(this._element)) this.next();
                }
            },
            {
                key: "prev",
                value: function prev() {
                    this._slide(ORDER_PREV);
                }
            },
            {
                key: "pause",
                value: function pause() {
                    if (this._isSliding) triggerTransitionEnd(this._element);
                    this._clearInterval();
                }
            },
            {
                key: "cycle",
                value: function cycle() {
                    var _this = this;
                    this._clearInterval();
                    this._updateInterval();
                    this._interval = setInterval(function() {
                        return _this.nextWhenVisible();
                    }, this._config.interval);
                }
            },
            {
                key: "_maybeEnableCycle",
                value: function _maybeEnableCycle() {
                    var _this = this;
                    if (!this._config.ride) return;
                    if (this._isSliding) {
                        EventHandler.one(this._element, EVENT_SLID, function() {
                            return _this.cycle();
                        });
                        return;
                    }
                    this.cycle();
                }
            },
            {
                key: "to",
                value: function to(index) {
                    var _this = this;
                    var items = this._getItems();
                    if (index > items.length - 1 || index < 0) return;
                    if (this._isSliding) {
                        EventHandler.one(this._element, EVENT_SLID, function() {
                            return _this.to(index);
                        });
                        return;
                    }
                    var activeIndex = this._getItemIndex(this._getActive());
                    if (activeIndex === index) return;
                    var order = index > activeIndex ? ORDER_NEXT : ORDER_PREV;
                    this._slide(order, items[index]);
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    if (this._swipeHelper) this._swipeHelper.dispose();
                    (0, $00e9f136d8b86c33$export$71511d61b312f219)((0, $81c9c858187986cb$export$71511d61b312f219)(Carousel.prototype), "dispose", this).call(this);
                }
            },
            {
                // Private
                key: "_configAfterMerge",
                value: function _configAfterMerge(config) {
                    config.defaultInterval = config.interval;
                    return config;
                }
            },
            {
                key: "_addEventListeners",
                value: function _addEventListeners() {
                    var _this = this;
                    if (this._config.keyboard) EventHandler.on(this._element, EVENT_KEYDOWN$1, function(event) {
                        return _this._keydown(event);
                    });
                    if (this._config.pause === 'hover') {
                        EventHandler.on(this._element, EVENT_MOUSEENTER$1, function() {
                            return _this.pause();
                        });
                        EventHandler.on(this._element, EVENT_MOUSELEAVE$1, function() {
                            return _this._maybeEnableCycle();
                        });
                    }
                    if (this._config.touch && Swipe.isSupported()) this._addTouchEventListeners();
                }
            },
            {
                key: "_addTouchEventListeners",
                value: function _addTouchEventListeners() {
                    var _this = this;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = SelectorEngine.find(SELECTOR_ITEM_IMG, this._element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var img = _step.value;
                            EventHandler.on(img, EVENT_DRAG_START, function(event) {
                                return event.preventDefault();
                            });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var endCallBack = function() {
                        if (_this._config.pause !== 'hover') return;
                        // If it's a touch-enabled device, mouseenter/leave are fired as
                        // part of the mouse compatibility events on first tap - the carousel
                        // would stop cycling until user tapped out of it;
                        // here, we listen for touchend, explicitly pause the carousel
                        // (as if it's the second time we tap on it, mouseenter compat event
                        // is NOT fired) and after a timeout (to allow for mouse compatibility
                        // events to fire) we explicitly restart cycling
                        _this.pause();
                        if (_this.touchTimeout) clearTimeout(_this.touchTimeout);
                        _this.touchTimeout = setTimeout(function() {
                            return _this._maybeEnableCycle();
                        }, TOUCHEVENT_COMPAT_WAIT + _this._config.interval);
                    };
                    var swipeConfig = {
                        leftCallback: function() {
                            return _this._slide(_this._directionToOrder(DIRECTION_LEFT));
                        },
                        rightCallback: function() {
                            return _this._slide(_this._directionToOrder(DIRECTION_RIGHT));
                        },
                        endCallback: endCallBack
                    };
                    this._swipeHelper = new Swipe(this._element, swipeConfig);
                }
            },
            {
                key: "_keydown",
                value: function _keydown(event) {
                    if (/input|textarea/i.test(event.target.tagName)) return;
                    var direction = KEY_TO_DIRECTION[event.key];
                    if (direction) {
                        event.preventDefault();
                        this._slide(this._directionToOrder(direction));
                    }
                }
            },
            {
                key: "_getItemIndex",
                value: function _getItemIndex(element) {
                    return this._getItems().indexOf(element);
                }
            },
            {
                key: "_setActiveIndicatorElement",
                value: function _setActiveIndicatorElement(index) {
                    if (!this._indicatorsElement) return;
                    var activeIndicator = SelectorEngine.findOne(SELECTOR_ACTIVE, this._indicatorsElement);
                    activeIndicator.classList.remove(CLASS_NAME_ACTIVE$2);
                    activeIndicator.removeAttribute('aria-current');
                    var newActiveIndicator = SelectorEngine.findOne('[data-bs-slide-to="'.concat(index, '"]'), this._indicatorsElement);
                    if (newActiveIndicator) {
                        newActiveIndicator.classList.add(CLASS_NAME_ACTIVE$2);
                        newActiveIndicator.setAttribute('aria-current', 'true');
                    }
                }
            },
            {
                key: "_updateInterval",
                value: function _updateInterval() {
                    var element = this._activeElement || this._getActive();
                    if (!element) return;
                    var elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
                    this._config.interval = elementInterval || this._config.defaultInterval;
                }
            },
            {
                key: "_slide",
                value: function _slide(order) {
                    var _this = this;
                    var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                    if (this._isSliding) return;
                    var activeElement = this._getActive();
                    var isNext = order === ORDER_NEXT;
                    var nextElement = element || getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
                    if (nextElement === activeElement) return;
                    var nextElementIndex = this._getItemIndex(nextElement);
                    var triggerEvent = function(eventName) {
                        return EventHandler.trigger(_this._element, eventName, {
                            relatedTarget: nextElement,
                            direction: _this._orderToDirection(order),
                            from: _this._getItemIndex(activeElement),
                            to: nextElementIndex
                        });
                    };
                    var slideEvent = triggerEvent(EVENT_SLIDE);
                    if (slideEvent.defaultPrevented) return;
                    if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
                    // TODO: change tests that use empty divs to avoid this check
                    return;
                    var isCycling = Boolean(this._interval);
                    this.pause();
                    this._isSliding = true;
                    this._setActiveIndicatorElement(nextElementIndex);
                    this._activeElement = nextElement;
                    var directionalClassName = isNext ? CLASS_NAME_START : CLASS_NAME_END;
                    var orderClassName = isNext ? CLASS_NAME_NEXT : CLASS_NAME_PREV;
                    nextElement.classList.add(orderClassName);
                    reflow(nextElement);
                    activeElement.classList.add(directionalClassName);
                    nextElement.classList.add(directionalClassName);
                    var completeCallBack = function() {
                        nextElement.classList.remove(directionalClassName, orderClassName);
                        nextElement.classList.add(CLASS_NAME_ACTIVE$2);
                        activeElement.classList.remove(CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
                        _this._isSliding = false;
                        triggerEvent(EVENT_SLID);
                    };
                    this._queueCallback(completeCallBack, activeElement, this._isAnimated());
                    if (isCycling) this.cycle();
                }
            },
            {
                key: "_isAnimated",
                value: function _isAnimated() {
                    return this._element.classList.contains(CLASS_NAME_SLIDE);
                }
            },
            {
                key: "_getActive",
                value: function _getActive() {
                    return SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM, this._element);
                }
            },
            {
                key: "_getItems",
                value: function _getItems() {
                    return SelectorEngine.find(SELECTOR_ITEM, this._element);
                }
            },
            {
                key: "_clearInterval",
                value: function _clearInterval() {
                    if (this._interval) {
                        clearInterval(this._interval);
                        this._interval = null;
                    }
                }
            },
            {
                key: "_directionToOrder",
                value: function _directionToOrder(direction) {
                    if (isRTL()) return direction === DIRECTION_LEFT ? ORDER_PREV : ORDER_NEXT;
                    return direction === DIRECTION_LEFT ? ORDER_NEXT : ORDER_PREV;
                }
            },
            {
                key: "_orderToDirection",
                value: function _orderToDirection(order) {
                    if (isRTL()) return order === ORDER_PREV ? DIRECTION_LEFT : DIRECTION_RIGHT;
                    return order === ORDER_PREV ? DIRECTION_RIGHT : DIRECTION_LEFT;
                }
            }
        ], [
            {
                key: "Default",
                get: // Getters
                function get() {
                    return Default$b;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$b;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$c;
                }
            },
            {
                key: "jQueryInterface",
                value: // Static
                function jQueryInterface(config) {
                    return this.each(function() {
                        var data = Carousel.getOrCreateInstance(this, config);
                        if (typeof config === 'number') {
                            data.to(config);
                            return;
                        }
                        if (typeof config === 'string') {
                            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                            data[config]();
                        }
                    });
                }
            }
        ]);
        return Carousel;
    }(BaseComponent);
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$5, SELECTOR_DATA_SLIDE, function(event) {
        var target = SelectorEngine.getElementFromSelector(this);
        if (!target || !target.classList.contains(CLASS_NAME_CAROUSEL)) return;
        event.preventDefault();
        var carousel = Carousel.getOrCreateInstance(target);
        var slideIndex = this.getAttribute('data-bs-slide-to');
        if (slideIndex) {
            carousel.to(slideIndex);
            carousel._maybeEnableCycle();
            return;
        }
        if (Manipulator.getDataAttribute(this, 'slide') === 'next') {
            carousel.next();
            carousel._maybeEnableCycle();
            return;
        }
        carousel.prev();
        carousel._maybeEnableCycle();
    });
    EventHandler.on(window, EVENT_LOAD_DATA_API$3, function() {
        var carousels = SelectorEngine.find(SELECTOR_DATA_RIDE);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = carousels[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var carousel = _step.value;
                Carousel.getOrCreateInstance(carousel);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Carousel);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap collapse.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var NAME$b = 'collapse';
    var DATA_KEY$7 = 'bs.collapse';
    var EVENT_KEY$7 = ".".concat(DATA_KEY$7);
    var DATA_API_KEY$4 = '.data-api';
    var EVENT_SHOW$6 = "show".concat(EVENT_KEY$7);
    var EVENT_SHOWN$6 = "shown".concat(EVENT_KEY$7);
    var EVENT_HIDE$6 = "hide".concat(EVENT_KEY$7);
    var EVENT_HIDDEN$6 = "hidden".concat(EVENT_KEY$7);
    var EVENT_CLICK_DATA_API$4 = "click".concat(EVENT_KEY$7).concat(DATA_API_KEY$4);
    var CLASS_NAME_SHOW$7 = 'show';
    var CLASS_NAME_COLLAPSE = 'collapse';
    var CLASS_NAME_COLLAPSING = 'collapsing';
    var CLASS_NAME_COLLAPSED = 'collapsed';
    var CLASS_NAME_DEEPER_CHILDREN = ":scope .".concat(CLASS_NAME_COLLAPSE, " .").concat(CLASS_NAME_COLLAPSE);
    var CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
    var WIDTH = 'width';
    var HEIGHT = 'height';
    var SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
    var SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
    var Default$a = {
        parent: null,
        toggle: true
    };
    var DefaultType$a = {
        parent: '(null|element)',
        toggle: 'boolean'
    };
    /**
   * Class definition
   */ var Collapse = /*#__PURE__*/ function(BaseComponent) {
        (0, $99c2e1b2c4a01e52$export$71511d61b312f219)(Collapse, BaseComponent);
        function Collapse(element, config) {
            (0, $369e92947825c2b5$export$71511d61b312f219)(this, Collapse);
            var _this;
            _this = (0, $972025e4d4e45634$export$71511d61b312f219)(this, Collapse, [
                element,
                config
            ]);
            _this._isTransitioning = false;
            _this._triggerArray = [];
            var toggleList = SelectorEngine.find(SELECTOR_DATA_TOGGLE$4);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = toggleList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var elem = _step.value;
                    var selector = SelectorEngine.getSelectorFromElement(elem);
                    var filterElement = SelectorEngine.find(selector).filter(function(foundElement) {
                        return foundElement === _this._element;
                    });
                    if (selector !== null && filterElement.length) _this._triggerArray.push(elem);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            _this._initializeChildren();
            if (!_this._config.parent) _this._addAriaAndCollapsedClass(_this._triggerArray, _this._isShown());
            if (_this._config.toggle) _this.toggle();
            return _this;
        }
        (0, $11b219ef186b1c94$export$71511d61b312f219)(Collapse, [
            {
                // Public
                key: "toggle",
                value: function toggle() {
                    if (this._isShown()) this.hide();
                    else this.show();
                }
            },
            {
                key: "show",
                value: function show() {
                    var _this = this;
                    if (this._isTransitioning || this._isShown()) return;
                    var activeChildren = [];
                    // find active children
                    if (this._config.parent) activeChildren = this._getFirstLevelChildren(SELECTOR_ACTIVES).filter(function(element) {
                        return element !== _this._element;
                    }).map(function(element) {
                        return Collapse.getOrCreateInstance(element, {
                            toggle: false
                        });
                    });
                    if (activeChildren.length && activeChildren[0]._isTransitioning) return;
                    var startEvent = EventHandler.trigger(this._element, EVENT_SHOW$6);
                    if (startEvent.defaultPrevented) return;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = activeChildren[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var activeInstance = _step.value;
                            activeInstance.hide();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var dimension = this._getDimension();
                    this._element.classList.remove(CLASS_NAME_COLLAPSE);
                    this._element.classList.add(CLASS_NAME_COLLAPSING);
                    this._element.style[dimension] = 0;
                    this._addAriaAndCollapsedClass(this._triggerArray, true);
                    this._isTransitioning = true;
                    var complete = function() {
                        _this._isTransitioning = false;
                        _this._element.classList.remove(CLASS_NAME_COLLAPSING);
                        _this._element.classList.add(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$7);
                        _this._element.style[dimension] = '';
                        EventHandler.trigger(_this._element, EVENT_SHOWN$6);
                    };
                    var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
                    var scrollSize = "scroll".concat(capitalizedDimension);
                    this._queueCallback(complete, this._element, true);
                    this._element.style[dimension] = "".concat(this._element[scrollSize], "px");
                }
            },
            {
                key: "hide",
                value: function hide() {
                    var _this = this;
                    if (this._isTransitioning || !this._isShown()) return;
                    var startEvent = EventHandler.trigger(this._element, EVENT_HIDE$6);
                    if (startEvent.defaultPrevented) return;
                    var dimension = this._getDimension();
                    this._element.style[dimension] = "".concat(this._element.getBoundingClientRect()[dimension], "px");
                    reflow(this._element);
                    this._element.classList.add(CLASS_NAME_COLLAPSING);
                    this._element.classList.remove(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$7);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this._triggerArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var trigger = _step.value;
                            var element = SelectorEngine.getElementFromSelector(trigger);
                            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                                trigger
                            ], false);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this._isTransitioning = true;
                    var complete = function() {
                        _this._isTransitioning = false;
                        _this._element.classList.remove(CLASS_NAME_COLLAPSING);
                        _this._element.classList.add(CLASS_NAME_COLLAPSE);
                        EventHandler.trigger(_this._element, EVENT_HIDDEN$6);
                    };
                    this._element.style[dimension] = '';
                    this._queueCallback(complete, this._element, true);
                }
            },
            {
                // Private
                key: "_isShown",
                value: function _isShown() {
                    var element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._element;
                    return element.classList.contains(CLASS_NAME_SHOW$7);
                }
            },
            {
                key: "_configAfterMerge",
                value: function _configAfterMerge(config) {
                    config.toggle = Boolean(config.toggle); // Coerce string values
                    config.parent = getElement(config.parent);
                    return config;
                }
            },
            {
                key: "_getDimension",
                value: function _getDimension() {
                    return this._element.classList.contains(CLASS_NAME_HORIZONTAL) ? WIDTH : HEIGHT;
                }
            },
            {
                key: "_initializeChildren",
                value: function _initializeChildren() {
                    if (!this._config.parent) return;
                    var children = this._getFirstLevelChildren(SELECTOR_DATA_TOGGLE$4);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            var selected = SelectorEngine.getElementFromSelector(element);
                            if (selected) this._addAriaAndCollapsedClass([
                                element
                            ], this._isShown(selected));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "_getFirstLevelChildren",
                value: function _getFirstLevelChildren(selector) {
                    var children = SelectorEngine.find(CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
                    // remove children if greater depth
                    return SelectorEngine.find(selector, this._config.parent).filter(function(element) {
                        return !children.includes(element);
                    });
                }
            },
            {
                key: "_addAriaAndCollapsedClass",
                value: function _addAriaAndCollapsedClass(triggerArray, isOpen) {
                    if (!triggerArray.length) return;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = triggerArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            element.classList.toggle(CLASS_NAME_COLLAPSED, !isOpen);
                            element.setAttribute('aria-expanded', isOpen);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        ], [
            {
                key: "Default",
                get: // Getters
                function get() {
                    return Default$a;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$a;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$b;
                }
            },
            {
                key: "jQueryInterface",
                value: // Static
                function jQueryInterface(config) {
                    var _config = {};
                    if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
                    return this.each(function() {
                        var data = Collapse.getOrCreateInstance(this, _config);
                        if (typeof config === 'string') {
                            if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                            data[config]();
                        }
                    });
                }
            }
        ]);
        return Collapse;
    }(BaseComponent);
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$4, SELECTOR_DATA_TOGGLE$4, function(event) {
        // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
        if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = SelectorEngine.getMultipleElementsFromSelector(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                Collapse.getOrCreateInstance(element, {
                    toggle: false
                }).toggle();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Collapse);
    var top = 'top';
    var bottom = 'bottom';
    var right = 'right';
    var left = 'left';
    var auto = 'auto';
    var basePlacements = [
        top,
        bottom,
        right,
        left
    ];
    var start = 'start';
    var end = 'end';
    var clippingParents = 'clippingParents';
    var viewport = 'viewport';
    var popper = 'popper';
    var reference = 'reference';
    var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
        return acc.concat([
            placement + "-" + start,
            placement + "-" + end
        ]);
    }, []);
    var placements = /*#__PURE__*/ [].concat(basePlacements, [
        auto
    ]).reduce(function(acc, placement) {
        return acc.concat([
            placement,
            placement + "-" + start,
            placement + "-" + end
        ]);
    }, []); // modifiers that need to read the DOM
    var beforeRead = 'beforeRead';
    var read = 'read';
    var afterRead = 'afterRead'; // pure-logic modifiers
    var beforeMain = 'beforeMain';
    var main = 'main';
    var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
    var beforeWrite = 'beforeWrite';
    var write = 'write';
    var afterWrite = 'afterWrite';
    var modifierPhases = [
        beforeRead,
        read,
        afterRead,
        beforeMain,
        main,
        afterMain,
        beforeWrite,
        write,
        afterWrite
    ];
    function getNodeName(element) {
        return element ? (element.nodeName || '').toLowerCase() : null;
    }
    function getWindow(node) {
        if (node == null) return window;
        if (node.toString() !== '[object Window]') {
            var ownerDocument = node.ownerDocument;
            return ownerDocument ? ownerDocument.defaultView || window : window;
        }
        return node;
    }
    function isElement(node) {
        var OwnElement = getWindow(node).Element;
        return node instanceof OwnElement || node instanceof Element;
    }
    function isHTMLElement(node) {
        var OwnElement = getWindow(node).HTMLElement;
        return node instanceof OwnElement || node instanceof HTMLElement;
    }
    function isShadowRoot(node) {
        // IE 11 has no ShadowRoot
        if (typeof ShadowRoot === 'undefined') return false;
        var OwnElement = getWindow(node).ShadowRoot;
        return node instanceof OwnElement || node instanceof ShadowRoot;
    }
    // and applies them to the HTMLElements such as popper and arrow
    function applyStyles(_ref) {
        var state = _ref.state;
        Object.keys(state.elements).forEach(function(name) {
            var style = state.styles[name] || {};
            var attributes = state.attributes[name] || {};
            var element = state.elements[name]; // arrow is optional + virtual elements
            if (!isHTMLElement(element) || !getNodeName(element)) return;
             // Flow doesn't support to extend this property, but it's the most
            // effective way to apply styles to an HTMLElement
            // $FlowFixMe[cannot-write]
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(name) {
                var value = attributes[name];
                if (value === false) element.removeAttribute(name);
                else element.setAttribute(name, value === true ? '' : value);
            });
        });
    }
    function effect$2(_ref2) {
        var state = _ref2.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
        return function() {
            Object.keys(state.elements).forEach(function(name) {
                var element = state.elements[name];
                var attributes = state.attributes[name] || {};
                var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
                var style = styleProperties.reduce(function(style, property) {
                    style[property] = '';
                    return style;
                }, {}); // arrow is optional + virtual elements
                if (!isHTMLElement(element) || !getNodeName(element)) return;
                Object.assign(element.style, style);
                Object.keys(attributes).forEach(function(attribute) {
                    element.removeAttribute(attribute);
                });
            });
        };
    } // eslint-disable-next-line import/no-unused-modules
    var applyStyles$1 = {
        name: 'applyStyles',
        enabled: true,
        phase: 'write',
        fn: applyStyles,
        effect: effect$2,
        requires: [
            'computeStyles'
        ]
    };
    function getBasePlacement(placement) {
        return placement.split('-')[0];
    }
    var max = Math.max;
    var min = Math.min;
    var round = Math.round;
    function getUAString() {
        var uaData = navigator.userAgentData;
        if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
            return item.brand + "/" + item.version;
        }).join(' ');
        return navigator.userAgent;
    }
    function isLayoutViewport() {
        return !/^((?!chrome|android).)*safari/i.test(getUAString());
    }
    function getBoundingClientRect(element, includeScale, isFixedStrategy) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        var clientRect = element.getBoundingClientRect();
        var scaleX = 1;
        var scaleY = 1;
        if (includeScale && isHTMLElement(element)) {
            scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
            scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
        }
        var _ref = isElement(element) ? getWindow(element) : window, visualViewport = _ref.visualViewport;
        var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
        var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
        var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
        var width = clientRect.width / scaleX;
        var height = clientRect.height / scaleY;
        return {
            width: width,
            height: height,
            top: y,
            right: x + width,
            bottom: y + height,
            left: x,
            x: x,
            y: y
        };
    }
    // means it doesn't take into account transforms.
    function getLayoutRect(element) {
        var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
        // Fixes https://github.com/popperjs/popper-core/issues/1223
        var width = element.offsetWidth;
        var height = element.offsetHeight;
        if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
        if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
        return {
            x: element.offsetLeft,
            y: element.offsetTop,
            width: width,
            height: height
        };
    }
    function contains(parent, child) {
        var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
        if (parent.contains(child)) return true;
        else if (rootNode && isShadowRoot(rootNode)) {
            var next = child;
            do {
                if (next && parent.isSameNode(next)) return true;
                 // $FlowFixMe[prop-missing]: need a better way to handle this...
                next = next.parentNode || next.host;
            }while (next);
        } // Give up, the result is false
        return false;
    }
    function getComputedStyle$1(element) {
        return getWindow(element).getComputedStyle(element);
    }
    function isTableElement(element) {
        return [
            'table',
            'td',
            'th'
        ].indexOf(getNodeName(element)) >= 0;
    }
    function getDocumentElement(element) {
        // $FlowFixMe[incompatible-return]: assume body is always available
        return ((isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
    }
    function getParentNode(element) {
        if (getNodeName(element) === 'html') return element;
        return(// $FlowFixMe[incompatible-return]
        // $FlowFixMe[prop-missing]
        element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
        element.parentNode || (isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
        // $FlowFixMe[incompatible-call]: HTMLElement is a Node
        getDocumentElement(element) // fallback
        );
    }
    function getTrueOffsetParent(element) {
        if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
        getComputedStyle$1(element).position === 'fixed') return null;
        return element.offsetParent;
    } // `.offsetParent` reports `null` for fixed elements, while absolute elements
    // return the containing block
    function getContainingBlock(element) {
        var isFirefox = /firefox/i.test(getUAString());
        var isIE = /Trident/i.test(getUAString());
        if (isIE && isHTMLElement(element)) {
            // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
            var elementCss = getComputedStyle$1(element);
            if (elementCss.position === 'fixed') return null;
        }
        var currentNode = getParentNode(element);
        if (isShadowRoot(currentNode)) currentNode = currentNode.host;
        while(isHTMLElement(currentNode) && [
            'html',
            'body'
        ].indexOf(getNodeName(currentNode)) < 0){
            var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
            // create a containing block.
            // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
            if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
                'transform',
                'perspective'
            ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
            else currentNode = currentNode.parentNode;
        }
        return null;
    } // Gets the closest ancestor positioned element. Handles some edge cases,
    // such as table ancestors and cross browser bugs.
    function getOffsetParent(element) {
        var _$window = getWindow(element);
        var offsetParent = getTrueOffsetParent(element);
        while(offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static')offsetParent = getTrueOffsetParent(offsetParent);
        if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) return _$window;
        return offsetParent || getContainingBlock(element) || _$window;
    }
    function getMainAxisFromPlacement(placement) {
        return [
            'top',
            'bottom'
        ].indexOf(placement) >= 0 ? 'x' : 'y';
    }
    function within(min$1, value, max$1) {
        return max(min$1, min(value, max$1));
    }
    function withinMaxClamp(min, value, max) {
        var v = within(min, value, max);
        return v > max ? max : v;
    }
    function getFreshSideObject() {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
    }
    function mergePaddingObject(paddingObject) {
        return Object.assign({}, getFreshSideObject(), paddingObject);
    }
    function expandToHashMap(value, keys) {
        return keys.reduce(function(hashMap, key) {
            hashMap[key] = value;
            return hashMap;
        }, {});
    }
    var toPaddingObject = function toPaddingObject(padding, state) {
        padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
            placement: state.placement
        })) : padding;
        return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
    };
    function arrow(_ref) {
        var _state$modifiersData$;
        var state = _ref.state, name = _ref.name, options = _ref.options;
        var arrowElement = state.elements.arrow;
        var _$popperOffsets = state.modifiersData.popperOffsets;
        var basePlacement = getBasePlacement(state.placement);
        var axis = getMainAxisFromPlacement(basePlacement);
        var isVertical = [
            left,
            right
        ].indexOf(basePlacement) >= 0;
        var len = isVertical ? 'height' : 'width';
        if (!arrowElement || !_$popperOffsets) return;
        var paddingObject = toPaddingObject(options.padding, state);
        var arrowRect = getLayoutRect(arrowElement);
        var minProp = axis === 'y' ? top : left;
        var maxProp = axis === 'y' ? bottom : right;
        var endDiff = state.rects.reference[len] + state.rects.reference[axis] - _$popperOffsets[axis] - state.rects.popper[len];
        var startDiff = _$popperOffsets[axis] - state.rects.reference[axis];
        var arrowOffsetParent = getOffsetParent(arrowElement);
        var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
        var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
        // outside of the popper bounds
        var min = paddingObject[minProp];
        var max = clientSize - arrowRect[len] - paddingObject[maxProp];
        var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
        var _$offset = within(min, center, max); // Prevents breaking syntax highlighting...
        var axisProp = axis;
        state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = _$offset, _state$modifiersData$.centerOffset = _$offset - center, _state$modifiersData$);
    }
    function effect$1(_ref2) {
        var state = _ref2.state, options = _ref2.options;
        var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
        if (arrowElement == null) return;
         // CSS selector
        if (typeof arrowElement === 'string') {
            arrowElement = state.elements.popper.querySelector(arrowElement);
            if (!arrowElement) return;
        }
        if (!contains(state.elements.popper, arrowElement)) return;
        state.elements.arrow = arrowElement;
    } // eslint-disable-next-line import/no-unused-modules
    var arrow$1 = {
        name: 'arrow',
        enabled: true,
        phase: 'main',
        fn: arrow,
        effect: effect$1,
        requires: [
            'popperOffsets'
        ],
        requiresIfExists: [
            'preventOverflow'
        ]
    };
    function getVariation(placement) {
        return placement.split('-')[1];
    }
    var unsetSides = {
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto'
    }; // Round the offsets to the nearest suitable subpixel based on the DPR.
    // Zooming can change the DPR, but it seems to report a value that will
    // cleanly divide the values into the appropriate subpixels.
    function roundOffsetsByDPR(_ref, win) {
        var x = _ref.x, y = _ref.y;
        var dpr = win.devicePixelRatio || 1;
        return {
            x: round(x * dpr) / dpr || 0,
            y: round(y * dpr) / dpr || 0
        };
    }
    function mapToStyles(_ref2) {
        var _Object$assign2;
        var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
        var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
        var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
            x: x,
            y: y
        }) : {
            x: x,
            y: y
        };
        x = _ref3.x;
        y = _ref3.y;
        var hasX = offsets.hasOwnProperty('x');
        var hasY = offsets.hasOwnProperty('y');
        var sideX = left;
        var sideY = top;
        var win = window;
        if (adaptive) {
            var offsetParent = getOffsetParent(popper);
            var heightProp = 'clientHeight';
            var widthProp = 'clientWidth';
            if (offsetParent === getWindow(popper)) {
                offsetParent = getDocumentElement(popper);
                if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
                    heightProp = 'scrollHeight';
                    widthProp = 'scrollWidth';
                }
            } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
            offsetParent;
            if (placement === top || (placement === left || placement === right) && variation === end) {
                sideY = bottom;
                var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
                y -= offsetY - popperRect.height;
                y *= gpuAcceleration ? 1 : -1;
            }
            if (placement === left || (placement === top || placement === bottom) && variation === end) {
                sideX = right;
                var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
                x -= offsetX - popperRect.width;
                x *= gpuAcceleration ? 1 : -1;
            }
        }
        var commonStyles = Object.assign({
            position: position
        }, adaptive && unsetSides);
        var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
            x: x,
            y: y
        }, getWindow(popper)) : {
            x: x,
            y: y
        };
        x = _ref4.x;
        y = _ref4.y;
        if (gpuAcceleration) {
            var _Object$assign;
            return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
        }
        return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
    }
    function computeStyles(_ref5) {
        var state = _ref5.state, options = _ref5.options;
        var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
        var commonStyles = {
            placement: getBasePlacement(state.placement),
            variation: getVariation(state.placement),
            popper: state.elements.popper,
            popperRect: state.rects.popper,
            gpuAcceleration: gpuAcceleration,
            isFixed: state.options.strategy === 'fixed'
        };
        if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.popperOffsets,
            position: state.options.strategy,
            adaptive: adaptive,
            roundOffsets: roundOffsets
        })));
        if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.arrow,
            position: 'absolute',
            adaptive: false,
            roundOffsets: roundOffsets
        })));
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-placement': state.placement
        });
    } // eslint-disable-next-line import/no-unused-modules
    var computeStyles$1 = {
        name: 'computeStyles',
        enabled: true,
        phase: 'beforeWrite',
        fn: computeStyles,
        data: {}
    };
    var passive = {
        passive: true
    };
    function effect(_ref) {
        var state = _ref.state, instance = _ref.instance, options = _ref.options;
        var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
        var _$window = getWindow(state.elements.popper);
        var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.addEventListener('scroll', instance.update, passive);
        });
        if (resize) _$window.addEventListener('resize', instance.update, passive);
        return function() {
            if (scroll) scrollParents.forEach(function(scrollParent) {
                scrollParent.removeEventListener('scroll', instance.update, passive);
            });
            if (resize) _$window.removeEventListener('resize', instance.update, passive);
        };
    } // eslint-disable-next-line import/no-unused-modules
    var eventListeners = {
        name: 'eventListeners',
        enabled: true,
        phase: 'write',
        fn: function fn() {},
        effect: effect,
        data: {}
    };
    var hash$1 = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    function getOppositePlacement(placement) {
        return placement.replace(/left|right|bottom|top/g, function(matched) {
            return hash$1[matched];
        });
    }
    var hash = {
        start: 'end',
        end: 'start'
    };
    function getOppositeVariationPlacement(placement) {
        return placement.replace(/start|end/g, function(matched) {
            return hash[matched];
        });
    }
    function getWindowScroll(node) {
        var win = getWindow(node);
        var scrollLeft = win.pageXOffset;
        var scrollTop = win.pageYOffset;
        return {
            scrollLeft: scrollLeft,
            scrollTop: scrollTop
        };
    }
    function getWindowScrollBarX(element) {
        // If <html> has a CSS width greater than the viewport, then this will be
        // incorrect for RTL.
        // Popper 1 is broken in this case and never had a bug report so let's assume
        // it's not an issue. I don't think anyone ever specifies width on <html>
        // anyway.
        // Browsers where the left scrollbar doesn't cause an issue report `0` for
        // this (e.g. Edge 2019, IE11, Safari)
        return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
    }
    function getViewportRect(element, strategy) {
        var win = getWindow(element);
        var html = getDocumentElement(element);
        var visualViewport = win.visualViewport;
        var width = html.clientWidth;
        var height = html.clientHeight;
        var x = 0;
        var y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            var layoutViewport = isLayoutViewport();
            if (layoutViewport || !layoutViewport && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x + getWindowScrollBarX(element),
            y: y
        };
    }
    // of the `<html>` and `<body>` rect bounds if horizontally scrollable
    function getDocumentRect(element) {
        var _element$ownerDocumen;
        var html = getDocumentElement(element);
        var winScroll = getWindowScroll(element);
        var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
        var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
        var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
        var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
        var y = -winScroll.scrollTop;
        if (getComputedStyle$1(body || html).direction === 'rtl') x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function isScrollParent(element) {
        // Firefox wants us to check `-x` and `-y` variations as well
        var _getComputedStyle = getComputedStyle$1(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
        return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
    }
    function getScrollParent(node) {
        if ([
            'html',
            'body',
            '#document'
        ].indexOf(getNodeName(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
        return node.ownerDocument.body;
        if (isHTMLElement(node) && isScrollParent(node)) return node;
        return getScrollParent(getParentNode(node));
    }
    /*
  given a DOM element, return the list of all scroll parents, up the list of ancesors
  until we get to the top window object. This list is what we attach scroll listeners
  to, because if any of these parent elements scroll, we'll need to re-calculate the
  reference element's position.
  */ function listScrollParents(element, list) {
        var _element$ownerDocumen;
        if (list === void 0) list = [];
        var scrollParent = getScrollParent(element);
        var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
        var win = getWindow(scrollParent);
        var target = isBody ? [
            win
        ].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
        var updatedList = list.concat(target);
        return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
    }
    function rectToClientRect(rect) {
        return Object.assign({}, rect, {
            left: rect.x,
            top: rect.y,
            right: rect.x + rect.width,
            bottom: rect.y + rect.height
        });
    }
    function getInnerBoundingClientRect(element, strategy) {
        var rect = getBoundingClientRect(element, false, strategy === 'fixed');
        rect.top = rect.top + element.clientTop;
        rect.left = rect.left + element.clientLeft;
        rect.bottom = rect.top + element.clientHeight;
        rect.right = rect.left + element.clientWidth;
        rect.width = element.clientWidth;
        rect.height = element.clientHeight;
        rect.x = rect.left;
        rect.y = rect.top;
        return rect;
    }
    function getClientRectFromMixedType(element, clippingParent, strategy) {
        return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
    } // A "clipping parent" is an overflowable container with the characteristic of
    // clipping (or hiding) overflowing elements with a position different from
    // `initial`
    function getClippingParents(element) {
        var clippingParents = listScrollParents(getParentNode(element));
        var canEscapeClipping = [
            'absolute',
            'fixed'
        ].indexOf(getComputedStyle$1(element).position) >= 0;
        var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
        if (!isElement(clipperElement)) return [];
         // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
        return clippingParents.filter(function(clippingParent) {
            return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
        });
    } // Gets the maximum area that the element is visible in due to any number of
    // clipping parents
    function getClippingRect(element, boundary, rootBoundary, strategy) {
        var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
        var clippingParents = [].concat(mainClippingParents, [
            rootBoundary
        ]);
        var firstClippingParent = clippingParents[0];
        var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
            var rect = getClientRectFromMixedType(element, clippingParent, strategy);
            accRect.top = max(rect.top, accRect.top);
            accRect.right = min(rect.right, accRect.right);
            accRect.bottom = min(rect.bottom, accRect.bottom);
            accRect.left = max(rect.left, accRect.left);
            return accRect;
        }, getClientRectFromMixedType(element, firstClippingParent, strategy));
        clippingRect.width = clippingRect.right - clippingRect.left;
        clippingRect.height = clippingRect.bottom - clippingRect.top;
        clippingRect.x = clippingRect.left;
        clippingRect.y = clippingRect.top;
        return clippingRect;
    }
    function computeOffsets(_ref) {
        var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
        var basePlacement = placement ? getBasePlacement(placement) : null;
        var variation = placement ? getVariation(placement) : null;
        var commonX = reference.x + reference.width / 2 - element.width / 2;
        var commonY = reference.y + reference.height / 2 - element.height / 2;
        var offsets;
        switch(basePlacement){
            case top:
                offsets = {
                    x: commonX,
                    y: reference.y - element.height
                };
                break;
            case bottom:
                offsets = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case right:
                offsets = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case left:
                offsets = {
                    x: reference.x - element.width,
                    y: commonY
                };
                break;
            default:
                offsets = {
                    x: reference.x,
                    y: reference.y
                };
        }
        var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
        if (mainAxis != null) {
            var len = mainAxis === 'y' ? 'height' : 'width';
            switch(variation){
                case start:
                    offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                    break;
                case end:
                    offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                    break;
            }
        }
        return offsets;
    }
    function detectOverflow(state, options) {
        if (options === void 0) options = {};
        var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
        var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
        var altContext = elementContext === popper ? reference : popper;
        var popperRect = state.rects.popper;
        var element = state.elements[altBoundary ? altContext : elementContext];
        var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
        var referenceClientRect = getBoundingClientRect(state.elements.reference);
        var _$popperOffsets = computeOffsets({
            reference: referenceClientRect,
            element: popperRect,
            placement: placement
        });
        var popperClientRect = rectToClientRect(Object.assign({}, popperRect, _$popperOffsets));
        var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
        // 0 or negative = within the clipping rect
        var overflowOffsets = {
            top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
            bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
            left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
            right: elementClientRect.right - clippingClientRect.right + paddingObject.right
        };
        var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
        if (elementContext === popper && offsetData) {
            var _$offset = offsetData[placement];
            Object.keys(overflowOffsets).forEach(function(key) {
                var multiply = [
                    right,
                    bottom
                ].indexOf(key) >= 0 ? 1 : -1;
                var axis = [
                    top,
                    bottom
                ].indexOf(key) >= 0 ? 'y' : 'x';
                overflowOffsets[key] += _$offset[axis] * multiply;
            });
        }
        return overflowOffsets;
    }
    function computeAutoPlacement(state, options) {
        if (options === void 0) options = {};
        var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
        var variation = getVariation(placement);
        var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement) {
            return getVariation(placement) === variation;
        }) : basePlacements;
        var allowedPlacements = placements$1.filter(function(placement) {
            return allowedAutoPlacements.indexOf(placement) >= 0;
        });
        if (allowedPlacements.length === 0) allowedPlacements = placements$1;
         // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
        var overflows = allowedPlacements.reduce(function(acc, placement) {
            acc[placement] = detectOverflow(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding
            })[getBasePlacement(placement)];
            return acc;
        }, {});
        return Object.keys(overflows).sort(function(a, b) {
            return overflows[a] - overflows[b];
        });
    }
    function getExpandedFallbackPlacements(placement) {
        if (getBasePlacement(placement) === auto) return [];
        var oppositePlacement = getOppositePlacement(placement);
        return [
            getOppositeVariationPlacement(placement),
            oppositePlacement,
            getOppositeVariationPlacement(oppositePlacement)
        ];
    }
    function flip(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        if (state.modifiersData[name]._skip) return;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
        var preferredPlacement = state.options.placement;
        var basePlacement = getBasePlacement(preferredPlacement);
        var isBasePlacement = basePlacement === preferredPlacement;
        var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
            getOppositePlacement(preferredPlacement)
        ] : getExpandedFallbackPlacements(preferredPlacement));
        var placements = [
            preferredPlacement
        ].concat(fallbackPlacements).reduce(function(acc, placement) {
            return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding,
                flipVariations: flipVariations,
                allowedAutoPlacements: allowedAutoPlacements
            }) : placement);
        }, []);
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var checksMap = new Map();
        var makeFallbackChecks = true;
        var firstFittingPlacement = placements[0];
        for(var i = 0; i < placements.length; i++){
            var placement = placements[i];
            var _basePlacement = getBasePlacement(placement);
            var isStartVariation = getVariation(placement) === start;
            var isVertical = [
                top,
                bottom
            ].indexOf(_basePlacement) >= 0;
            var len = isVertical ? 'width' : 'height';
            var overflow = detectOverflow(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                altBoundary: altBoundary,
                padding: padding
            });
            var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
            if (referenceRect[len] > popperRect[len]) mainVariationSide = getOppositePlacement(mainVariationSide);
            var altVariationSide = getOppositePlacement(mainVariationSide);
            var checks = [];
            if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
            if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
            if (checks.every(function(check) {
                return check;
            })) {
                firstFittingPlacement = placement;
                makeFallbackChecks = false;
                break;
            }
            checksMap.set(placement, checks);
        }
        if (makeFallbackChecks) {
            // `2` may be desired in some cases – research later
            var numberOfChecks = flipVariations ? 3 : 1;
            var _loop = function _loop(_i) {
                var fittingPlacement = placements.find(function(placement) {
                    var checks = checksMap.get(placement);
                    if (checks) return checks.slice(0, _i).every(function(check) {
                        return check;
                    });
                });
                if (fittingPlacement) {
                    firstFittingPlacement = fittingPlacement;
                    return "break";
                }
            };
            for(var _i = numberOfChecks; _i > 0; _i--){
                var _ret = _loop(_i);
                if (_ret === "break") break;
            }
        }
        if (state.placement !== firstFittingPlacement) {
            state.modifiersData[name]._skip = true;
            state.placement = firstFittingPlacement;
            state.reset = true;
        }
    } // eslint-disable-next-line import/no-unused-modules
    var flip$1 = {
        name: 'flip',
        enabled: true,
        phase: 'main',
        fn: flip,
        requiresIfExists: [
            'offset'
        ],
        data: {
            _skip: false
        }
    };
    function getSideOffsets(overflow, rect, preventedOffsets) {
        if (preventedOffsets === void 0) preventedOffsets = {
            x: 0,
            y: 0
        };
        return {
            top: overflow.top - rect.height - preventedOffsets.y,
            right: overflow.right - rect.width + preventedOffsets.x,
            bottom: overflow.bottom - rect.height + preventedOffsets.y,
            left: overflow.left - rect.width - preventedOffsets.x
        };
    }
    function isAnySideFullyClipped(overflow) {
        return [
            top,
            right,
            bottom,
            left
        ].some(function(side) {
            return overflow[side] >= 0;
        });
    }
    function hide(_ref) {
        var state = _ref.state, name = _ref.name;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var preventedOffsets = state.modifiersData.preventOverflow;
        var referenceOverflow = detectOverflow(state, {
            elementContext: 'reference'
        });
        var popperAltOverflow = detectOverflow(state, {
            altBoundary: true
        });
        var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
        var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
        var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
        var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
        state.modifiersData[name] = {
            referenceClippingOffsets: referenceClippingOffsets,
            popperEscapeOffsets: popperEscapeOffsets,
            isReferenceHidden: isReferenceHidden,
            hasPopperEscaped: hasPopperEscaped
        };
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-reference-hidden': isReferenceHidden,
            'data-popper-escaped': hasPopperEscaped
        });
    } // eslint-disable-next-line import/no-unused-modules
    var hide$1 = {
        name: 'hide',
        enabled: true,
        phase: 'main',
        requiresIfExists: [
            'preventOverflow'
        ],
        fn: hide
    };
    function distanceAndSkiddingToXY(placement, rects, offset) {
        var basePlacement = getBasePlacement(placement);
        var invertDistance = [
            left,
            top
        ].indexOf(basePlacement) >= 0 ? -1 : 1;
        var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
            placement: placement
        })) : offset, skidding = _ref[0], distance = _ref[1];
        skidding = skidding || 0;
        distance = (distance || 0) * invertDistance;
        return [
            left,
            right
        ].indexOf(basePlacement) >= 0 ? {
            x: distance,
            y: skidding
        } : {
            x: skidding,
            y: distance
        };
    }
    function offset(_ref2) {
        var state = _ref2.state, options = _ref2.options, name = _ref2.name;
        var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
            0,
            0
        ] : _options$offset;
        var data = placements.reduce(function(acc, placement) {
            acc[placement] = distanceAndSkiddingToXY(placement, state.rects, _$offset);
            return acc;
        }, {});
        var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
        if (state.modifiersData.popperOffsets != null) {
            state.modifiersData.popperOffsets.x += x;
            state.modifiersData.popperOffsets.y += y;
        }
        state.modifiersData[name] = data;
    } // eslint-disable-next-line import/no-unused-modules
    var offset$1 = {
        name: 'offset',
        enabled: true,
        phase: 'main',
        requires: [
            'popperOffsets'
        ],
        fn: offset
    };
    function popperOffsets(_ref) {
        var state = _ref.state, name = _ref.name;
        // Offsets are the actual position the popper needs to have to be
        // properly positioned near its reference element
        // This is the most basic placement, and will be adjusted by
        // the modifiers in the next step
        state.modifiersData[name] = computeOffsets({
            reference: state.rects.reference,
            element: state.rects.popper,
            placement: state.placement
        });
    } // eslint-disable-next-line import/no-unused-modules
    var popperOffsets$1 = {
        name: 'popperOffsets',
        enabled: true,
        phase: 'read',
        fn: popperOffsets,
        data: {}
    };
    function getAltAxis(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
    function preventOverflow(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
        var overflow = detectOverflow(state, {
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            altBoundary: altBoundary
        });
        var basePlacement = getBasePlacement(state.placement);
        var variation = getVariation(state.placement);
        var isBasePlacement = !variation;
        var mainAxis = getMainAxisFromPlacement(basePlacement);
        var altAxis = getAltAxis(mainAxis);
        var _$popperOffsets = state.modifiersData.popperOffsets;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
            placement: state.placement
        })) : tetherOffset;
        var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
            mainAxis: tetherOffsetValue,
            altAxis: tetherOffsetValue
        } : Object.assign({
            mainAxis: 0,
            altAxis: 0
        }, tetherOffsetValue);
        var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
        var data = {
            x: 0,
            y: 0
        };
        if (!_$popperOffsets) return;
        if (checkMainAxis) {
            var _offsetModifierState$;
            var mainSide = mainAxis === 'y' ? top : left;
            var altSide = mainAxis === 'y' ? bottom : right;
            var len = mainAxis === 'y' ? 'height' : 'width';
            var _$offset = _$popperOffsets[mainAxis];
            var min$1 = _$offset + overflow[mainSide];
            var max$1 = _$offset - overflow[altSide];
            var additive = tether ? -popperRect[len] / 2 : 0;
            var minLen = variation === start ? referenceRect[len] : popperRect[len];
            var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
            // outside the reference bounds
            var arrowElement = state.elements.arrow;
            var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
                width: 0,
                height: 0
            };
            var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
            var arrowPaddingMin = arrowPaddingObject[mainSide];
            var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
            // to include its full size in the calculation. If the reference is small
            // and near the edge of a boundary, the popper can overflow even if the
            // reference is not overflowing as well (e.g. virtual elements with no
            // width or height)
            var arrowLen = within(0, referenceRect[len], arrowRect[len]);
            var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
            var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
            var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
            var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
            var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
            var tetherMin = _$offset + minOffset - offsetModifierValue - clientOffset;
            var tetherMax = _$offset + maxOffset - offsetModifierValue;
            var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, _$offset, tether ? max(max$1, tetherMax) : max$1);
            _$popperOffsets[mainAxis] = preventedOffset;
            data[mainAxis] = preventedOffset - _$offset;
        }
        if (checkAltAxis) {
            var _offsetModifierState$2;
            var _mainSide = mainAxis === 'x' ? top : left;
            var _altSide = mainAxis === 'x' ? bottom : right;
            var _offset = _$popperOffsets[altAxis];
            var _len = altAxis === 'y' ? 'height' : 'width';
            var _min = _offset + overflow[_mainSide];
            var _max = _offset - overflow[_altSide];
            var isOriginSide = [
                top,
                left
            ].indexOf(basePlacement) !== -1;
            var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
            var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
            var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
            var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
            _$popperOffsets[altAxis] = _preventedOffset;
            data[altAxis] = _preventedOffset - _offset;
        }
        state.modifiersData[name] = data;
    } // eslint-disable-next-line import/no-unused-modules
    var preventOverflow$1 = {
        name: 'preventOverflow',
        enabled: true,
        phase: 'main',
        fn: preventOverflow,
        requiresIfExists: [
            'offset'
        ]
    };
    function getHTMLElementScroll(element) {
        return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
    }
    function getNodeScroll(node) {
        if (node === getWindow(node) || !isHTMLElement(node)) return getWindowScroll(node);
        else return getHTMLElementScroll(node);
    }
    function isElementScaled(element) {
        var rect = element.getBoundingClientRect();
        var scaleX = round(rect.width) / element.offsetWidth || 1;
        var scaleY = round(rect.height) / element.offsetHeight || 1;
        return scaleX !== 1 || scaleY !== 1;
    } // Returns the composite rect of an element relative to its offsetParent.
    // Composite means it takes into account transforms as well as layout.
    function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
        if (isFixed === void 0) isFixed = false;
        var isOffsetParentAnElement = isHTMLElement(offsetParent);
        var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
        var documentElement = getDocumentElement(offsetParent);
        var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
        var scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        var offsets = {
            x: 0,
            y: 0
        };
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
            isScrollParent(documentElement)) scroll = getNodeScroll(offsetParent);
            if (isHTMLElement(offsetParent)) {
                offsets = getBoundingClientRect(offsetParent, true);
                offsets.x += offsetParent.clientLeft;
                offsets.y += offsetParent.clientTop;
            } else if (documentElement) offsets.x = getWindowScrollBarX(documentElement);
        }
        return {
            x: rect.left + scroll.scrollLeft - offsets.x,
            y: rect.top + scroll.scrollTop - offsets.y,
            width: rect.width,
            height: rect.height
        };
    }
    function order(modifiers) {
        var map = new Map();
        var visited = new Set();
        var result = [];
        modifiers.forEach(function(modifier) {
            map.set(modifier.name, modifier);
        }); // On visiting object, check for its dependencies and visit them recursively
        function sort(modifier) {
            visited.add(modifier.name);
            var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
            requires.forEach(function(dep) {
                if (!visited.has(dep)) {
                    var depModifier = map.get(dep);
                    if (depModifier) sort(depModifier);
                }
            });
            result.push(modifier);
        }
        modifiers.forEach(function(modifier) {
            if (!visited.has(modifier.name)) // check for visited object
            sort(modifier);
        });
        return result;
    }
    function orderModifiers(modifiers) {
        // order based on dependencies
        var orderedModifiers = order(modifiers); // order based on phase
        return modifierPhases.reduce(function(acc, phase) {
            return acc.concat(orderedModifiers.filter(function(modifier) {
                return modifier.phase === phase;
            }));
        }, []);
    }
    function debounce(fn) {
        var pending;
        return function() {
            if (!pending) pending = new Promise(function(resolve) {
                Promise.resolve().then(function() {
                    pending = undefined;
                    resolve(fn());
                });
            });
            return pending;
        };
    }
    function mergeByName(modifiers) {
        var merged = modifiers.reduce(function(merged, current) {
            var existing = merged[current.name];
            merged[current.name] = existing ? Object.assign({}, existing, current, {
                options: Object.assign({}, existing.options, current.options),
                data: Object.assign({}, existing.data, current.data)
            }) : current;
            return merged;
        }, {}); // IE11 does not support Object.values
        return Object.keys(merged).map(function(key) {
            return merged[key];
        });
    }
    var DEFAULT_OPTIONS = {
        placement: 'bottom',
        modifiers: [],
        strategy: 'absolute'
    };
    function areValidElements() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return !args.some(function(element) {
            return !(element && typeof element.getBoundingClientRect === 'function');
        });
    }
    function popperGenerator(generatorOptions) {
        if (generatorOptions === void 0) generatorOptions = {};
        var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
        return function createPopper(reference, popper, options) {
            if (options === void 0) options = defaultOptions;
            var state = {
                placement: 'bottom',
                orderedModifiers: [],
                options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
                modifiersData: {},
                elements: {
                    reference: reference,
                    popper: popper
                },
                attributes: {},
                styles: {}
            };
            var effectCleanupFns = [];
            var isDestroyed = false;
            var instance = {
                state: state,
                setOptions: function setOptions(setOptionsAction) {
                    var _$options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                    cleanupModifierEffects();
                    state.options = Object.assign({}, defaultOptions, state.options, _$options);
                    state.scrollParents = {
                        reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
                        popper: listScrollParents(popper)
                    }; // Orders the modifiers based on their dependencies and `phase`
                    // properties
                    var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                    state.orderedModifiers = orderedModifiers.filter(function(m) {
                        return m.enabled;
                    });
                    runModifierEffects();
                    return instance.update();
                },
                // Sync update – it will always be executed, even if not necessary. This
                // is useful for low frequency updates where sync behavior simplifies the
                // logic.
                // For high frequency updates (e.g. `resize` and `scroll` events), always
                // prefer the async Popper#update method
                forceUpdate: function forceUpdate() {
                    if (isDestroyed) return;
                    var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                    // anymore
                    if (!areValidElements(_$reference, _$popper)) return;
                     // Store the reference and popper rects to be read by modifiers
                    state.rects = {
                        reference: getCompositeRect(_$reference, getOffsetParent(_$popper), state.options.strategy === 'fixed'),
                        popper: getLayoutRect(_$popper)
                    }; // Modifiers have the ability to reset the current update cycle. The
                    // most common use case for this is the `flip` modifier changing the
                    // placement, which then needs to re-run all the modifiers, because the
                    // logic was previously ran for the previous placement and is therefore
                    // stale/incorrect
                    state.reset = false;
                    state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                    // is filled with the initial data specified by the modifier. This means
                    // it doesn't persist and is fresh on each update.
                    // To ensure persistent data, use `${name}#persistent`
                    state.orderedModifiers.forEach(function(modifier) {
                        return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                    });
                    for(var index = 0; index < state.orderedModifiers.length; index++){
                        if (state.reset === true) {
                            state.reset = false;
                            index = -1;
                            continue;
                        }
                        var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                        if (typeof fn === 'function') state = fn({
                            state: state,
                            options: _options,
                            name: name,
                            instance: instance
                        }) || state;
                    }
                },
                // Async and optimistically optimized update – it will not be executed if
                // not necessary (debounced to run at most once-per-tick)
                update: debounce(function() {
                    return new Promise(function(resolve) {
                        instance.forceUpdate();
                        resolve(state);
                    });
                }),
                destroy: function destroy() {
                    cleanupModifierEffects();
                    isDestroyed = true;
                }
            };
            if (!areValidElements(reference, popper)) return instance;
            instance.setOptions(options).then(function(state) {
                if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
            }); // Modifiers have the ability to execute arbitrary code before the first
            // update cycle runs. They will be executed in the same order as the update
            // cycle. This is useful when a modifier adds some persistent data that
            // other modifiers need to use, but the modifier is run after the dependent
            // one.
            function runModifierEffects() {
                state.orderedModifiers.forEach(function(_ref) {
                    var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, _$effect = _ref.effect;
                    if (typeof _$effect === 'function') {
                        var cleanupFn = _$effect({
                            state: state,
                            name: name,
                            instance: instance,
                            options: _$options
                        });
                        var noopFn = function noopFn() {};
                        effectCleanupFns.push(cleanupFn || noopFn);
                    }
                });
            }
            function cleanupModifierEffects() {
                effectCleanupFns.forEach(function(fn) {
                    return fn();
                });
                effectCleanupFns = [];
            }
            return instance;
        };
    }
    var createPopper$2 = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules
    var defaultModifiers$1 = [
        eventListeners,
        popperOffsets$1,
        computeStyles$1,
        applyStyles$1
    ];
    var createPopper$1 = /*#__PURE__*/ popperGenerator({
        defaultModifiers: defaultModifiers$1
    }); // eslint-disable-next-line import/no-unused-modules
    var defaultModifiers = [
        eventListeners,
        popperOffsets$1,
        computeStyles$1,
        applyStyles$1,
        offset$1,
        flip$1,
        preventOverflow$1,
        arrow$1,
        hide$1
    ];
    var createPopper = /*#__PURE__*/ popperGenerator({
        defaultModifiers: defaultModifiers
    }); // eslint-disable-next-line import/no-unused-modules
    var Popper = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.defineProperty({
        __proto__: null,
        afterMain: afterMain,
        afterRead: afterRead,
        afterWrite: afterWrite,
        applyStyles: applyStyles$1,
        arrow: arrow$1,
        auto: auto,
        basePlacements: basePlacements,
        beforeMain: beforeMain,
        beforeRead: beforeRead,
        beforeWrite: beforeWrite,
        bottom: bottom,
        clippingParents: clippingParents,
        computeStyles: computeStyles$1,
        createPopper: createPopper,
        createPopperBase: createPopper$2,
        createPopperLite: createPopper$1,
        detectOverflow: detectOverflow,
        end: end,
        eventListeners: eventListeners,
        flip: flip$1,
        hide: hide$1,
        left: left,
        main: main,
        modifierPhases: modifierPhases,
        offset: offset$1,
        placements: placements,
        popper: popper,
        popperGenerator: popperGenerator,
        popperOffsets: popperOffsets$1,
        preventOverflow: preventOverflow$1,
        read: read,
        reference: reference,
        right: right,
        start: start,
        top: top,
        variationPlacements: variationPlacements,
        viewport: viewport,
        write: write
    }, Symbol.toStringTag, {
        value: 'Module'
    }));
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dropdown.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var NAME$a = 'dropdown';
    var DATA_KEY$6 = 'bs.dropdown';
    var EVENT_KEY$6 = ".".concat(DATA_KEY$6);
    var DATA_API_KEY$3 = '.data-api';
    var ESCAPE_KEY$2 = 'Escape';
    var TAB_KEY$1 = 'Tab';
    var ARROW_UP_KEY$1 = 'ArrowUp';
    var ARROW_DOWN_KEY$1 = 'ArrowDown';
    var RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
    var EVENT_HIDE$5 = "hide".concat(EVENT_KEY$6);
    var EVENT_HIDDEN$5 = "hidden".concat(EVENT_KEY$6);
    var EVENT_SHOW$5 = "show".concat(EVENT_KEY$6);
    var EVENT_SHOWN$5 = "shown".concat(EVENT_KEY$6);
    var EVENT_CLICK_DATA_API$3 = "click".concat(EVENT_KEY$6).concat(DATA_API_KEY$3);
    var EVENT_KEYDOWN_DATA_API = "keydown".concat(EVENT_KEY$6).concat(DATA_API_KEY$3);
    var EVENT_KEYUP_DATA_API = "keyup".concat(EVENT_KEY$6).concat(DATA_API_KEY$3);
    var CLASS_NAME_SHOW$6 = 'show';
    var CLASS_NAME_DROPUP = 'dropup';
    var CLASS_NAME_DROPEND = 'dropend';
    var CLASS_NAME_DROPSTART = 'dropstart';
    var CLASS_NAME_DROPUP_CENTER = 'dropup-center';
    var CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
    var SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
    var SELECTOR_DATA_TOGGLE_SHOWN = "".concat(SELECTOR_DATA_TOGGLE$3, ".").concat(CLASS_NAME_SHOW$6);
    var SELECTOR_MENU = '.dropdown-menu';
    var SELECTOR_NAVBAR = '.navbar';
    var SELECTOR_NAVBAR_NAV = '.navbar-nav';
    var SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
    var PLACEMENT_TOP = isRTL() ? 'top-end' : 'top-start';
    var PLACEMENT_TOPEND = isRTL() ? 'top-start' : 'top-end';
    var PLACEMENT_BOTTOM = isRTL() ? 'bottom-end' : 'bottom-start';
    var PLACEMENT_BOTTOMEND = isRTL() ? 'bottom-start' : 'bottom-end';
    var PLACEMENT_RIGHT = isRTL() ? 'left-start' : 'right-start';
    var PLACEMENT_LEFT = isRTL() ? 'right-start' : 'left-start';
    var PLACEMENT_TOPCENTER = 'top';
    var PLACEMENT_BOTTOMCENTER = 'bottom';
    var Default$9 = {
        autoClose: true,
        boundary: 'clippingParents',
        display: 'dynamic',
        offset: [
            0,
            2
        ],
        popperConfig: null,
        reference: 'toggle'
    };
    var DefaultType$9 = {
        autoClose: '(boolean|string)',
        boundary: '(string|element)',
        display: 'string',
        offset: '(array|string|function)',
        popperConfig: '(null|object|function)',
        reference: '(string|element|object)'
    };
    /**
   * Class definition
   */ var Dropdown = /*#__PURE__*/ function(BaseComponent) {
        (0, $99c2e1b2c4a01e52$export$71511d61b312f219)(Dropdown, BaseComponent);
        function Dropdown(element, config) {
            (0, $369e92947825c2b5$export$71511d61b312f219)(this, Dropdown);
            var _this;
            _this = (0, $972025e4d4e45634$export$71511d61b312f219)(this, Dropdown, [
                element,
                config
            ]);
            _this._popper = null;
            _this._parent = _this._element.parentNode; // dropdown wrapper
            // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
            _this._menu = SelectorEngine.next(_this._element, SELECTOR_MENU)[0] || SelectorEngine.prev(_this._element, SELECTOR_MENU)[0] || SelectorEngine.findOne(SELECTOR_MENU, _this._parent);
            _this._inNavbar = _this._detectNavbar();
            return _this;
        }
        (0, $11b219ef186b1c94$export$71511d61b312f219)(Dropdown, [
            {
                // Public
                key: "toggle",
                value: function toggle() {
                    return this._isShown() ? this.hide() : this.show();
                }
            },
            {
                key: "show",
                value: function show() {
                    var _instance;
                    if (isDisabled(this._element) || this._isShown()) return;
                    var relatedTarget = {
                        relatedTarget: this._element
                    };
                    var showEvent = EventHandler.trigger(this._element, EVENT_SHOW$5, relatedTarget);
                    if (showEvent.defaultPrevented) return;
                    this._createPopper();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    // If this is a touch-enabled device we add extra
                    // empty mouseover listeners to the body's immediate children;
                    // only needed because of broken event delegation on iOS
                    // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                    if ('ontouchstart' in document.documentElement && !this._parent.closest(SELECTOR_NAVBAR_NAV)) try {
                        for(var _iterator = (_instance = []).concat.apply(_instance, (0, $8d1416c8f734345e$export$71511d61b312f219)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            EventHandler.on(element, 'mouseover', noop);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this._element.focus();
                    this._element.setAttribute('aria-expanded', true);
                    this._menu.classList.add(CLASS_NAME_SHOW$6);
                    this._element.classList.add(CLASS_NAME_SHOW$6);
                    EventHandler.trigger(this._element, EVENT_SHOWN$5, relatedTarget);
                }
            },
            {
                key: "hide",
                value: function hide() {
                    if (isDisabled(this._element) || !this._isShown()) return;
                    var relatedTarget = {
                        relatedTarget: this._element
                    };
                    this._completeHide(relatedTarget);
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    if (this._popper) this._popper.destroy();
                    (0, $00e9f136d8b86c33$export$71511d61b312f219)((0, $81c9c858187986cb$export$71511d61b312f219)(Dropdown.prototype), "dispose", this).call(this);
                }
            },
            {
                key: "update",
                value: function update() {
                    this._inNavbar = this._detectNavbar();
                    if (this._popper) this._popper.update();
                }
            },
            {
                // Private
                key: "_completeHide",
                value: function _completeHide(relatedTarget) {
                    var _instance;
                    var hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$5, relatedTarget);
                    if (hideEvent.defaultPrevented) return;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    // If this is a touch-enabled device we remove the extra
                    // empty mouseover listeners we added for iOS support
                    if ('ontouchstart' in document.documentElement) try {
                        for(var _iterator = (_instance = []).concat.apply(_instance, (0, $8d1416c8f734345e$export$71511d61b312f219)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            EventHandler.off(element, 'mouseover', noop);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (this._popper) this._popper.destroy();
                    this._menu.classList.remove(CLASS_NAME_SHOW$6);
                    this._element.classList.remove(CLASS_NAME_SHOW$6);
                    this._element.setAttribute('aria-expanded', 'false');
                    Manipulator.removeDataAttribute(this._menu, 'popper');
                    EventHandler.trigger(this._element, EVENT_HIDDEN$5, relatedTarget);
                }
            },
            {
                key: "_getConfig",
                value: function _getConfig(config) {
                    config = (0, $00e9f136d8b86c33$export$71511d61b312f219)((0, $81c9c858187986cb$export$71511d61b312f219)(Dropdown.prototype), "_getConfig", this).call(this, config);
                    if ((0, $f4bb2077aa61b74c$export$71511d61b312f219)(config.reference) === 'object' && !isElement$1(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
                    throw new TypeError("".concat(NAME$a.toUpperCase(), ': Option "reference" provided type "object" without a required "getBoundingClientRect" method.'));
                    return config;
                }
            },
            {
                key: "_createPopper",
                value: function _createPopper() {
                    if (typeof Popper === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
                    var referenceElement = this._element;
                    if (this._config.reference === 'parent') referenceElement = this._parent;
                    else if (isElement$1(this._config.reference)) referenceElement = getElement(this._config.reference);
                    else if ((0, $f4bb2077aa61b74c$export$71511d61b312f219)(this._config.reference) === 'object') referenceElement = this._config.reference;
                    var popperConfig = this._getPopperConfig();
                    this._popper = createPopper(referenceElement, this._menu, popperConfig);
                }
            },
            {
                key: "_isShown",
                value: function _isShown() {
                    return this._menu.classList.contains(CLASS_NAME_SHOW$6);
                }
            },
            {
                key: "_getPlacement",
                value: function _getPlacement() {
                    var parentDropdown = this._parent;
                    if (parentDropdown.classList.contains(CLASS_NAME_DROPEND)) return PLACEMENT_RIGHT;
                    if (parentDropdown.classList.contains(CLASS_NAME_DROPSTART)) return PLACEMENT_LEFT;
                    if (parentDropdown.classList.contains(CLASS_NAME_DROPUP_CENTER)) return PLACEMENT_TOPCENTER;
                    if (parentDropdown.classList.contains(CLASS_NAME_DROPDOWN_CENTER)) return PLACEMENT_BOTTOMCENTER;
                    // We need to trim the value because custom properties can also include spaces
                    var isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
                    if (parentDropdown.classList.contains(CLASS_NAME_DROPUP)) return isEnd ? PLACEMENT_TOPEND : PLACEMENT_TOP;
                    return isEnd ? PLACEMENT_BOTTOMEND : PLACEMENT_BOTTOM;
                }
            },
            {
                key: "_detectNavbar",
                value: function _detectNavbar() {
                    return this._element.closest(SELECTOR_NAVBAR) !== null;
                }
            },
            {
                key: "_getOffset",
                value: function _getOffset() {
                    var _this = this;
                    var _$offset = this._config.offset;
                    if (typeof _$offset === 'string') return _$offset.split(',').map(function(value) {
                        return Number.parseInt(value, 10);
                    });
                    if (typeof _$offset === 'function') return function(popperData) {
                        return _$offset(popperData, _this._element);
                    };
                    return _$offset;
                }
            },
            {
                key: "_getPopperConfig",
                value: function _getPopperConfig() {
                    var defaultBsPopperConfig = {
                        placement: this._getPlacement(),
                        modifiers: [
                            {
                                name: 'preventOverflow',
                                options: {
                                    boundary: this._config.boundary
                                }
                            },
                            {
                                name: 'offset',
                                options: {
                                    offset: this._getOffset()
                                }
                            }
                        ]
                    };
                    // Disable Popper if we have a static display or Dropdown is in Navbar
                    if (this._inNavbar || this._config.display === 'static') {
                        Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
                        defaultBsPopperConfig.modifiers = [
                            {
                                name: 'applyStyles',
                                enabled: false
                            }
                        ];
                    }
                    return (0, $9bf4d105a019f48b$export$71511d61b312f219)({}, defaultBsPopperConfig, execute(this._config.popperConfig, [
                        undefined,
                        defaultBsPopperConfig
                    ]));
                }
            },
            {
                key: "_selectMenuItem",
                value: function _selectMenuItem(param) {
                    var key = param.key, target = param.target;
                    var items = SelectorEngine.find(SELECTOR_VISIBLE_ITEMS, this._menu).filter(function(element) {
                        return isVisible(element);
                    });
                    if (!items.length) return;
                    // if target isn't included in items (e.g. when expanding the dropdown)
                    // allow cycling to get the last item in case key equals ARROW_UP_KEY
                    getNextActiveElement(items, target, key === ARROW_DOWN_KEY$1, !items.includes(target)).focus();
                }
            }
        ], [
            {
                key: "Default",
                get: // Getters
                function get() {
                    return Default$9;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$9;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$a;
                }
            },
            {
                key: "jQueryInterface",
                value: // Static
                function jQueryInterface(config) {
                    return this.each(function() {
                        var data = Dropdown.getOrCreateInstance(this, config);
                        if (typeof config !== 'string') return;
                        if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    });
                }
            },
            {
                key: "clearMenus",
                value: function clearMenus(event) {
                    if (event.button === RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== TAB_KEY$1) return;
                    var openToggles = SelectorEngine.find(SELECTOR_DATA_TOGGLE_SHOWN);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = openToggles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var toggle = _step.value;
                            var context = Dropdown.getInstance(toggle);
                            if (!context || context._config.autoClose === false) continue;
                            var composedPath = event.composedPath();
                            var isMenuTarget = composedPath.includes(context._menu);
                            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
                            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
                            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
                            var relatedTarget = {
                                relatedTarget: context._element
                            };
                            if (event.type === 'click') relatedTarget.clickEvent = event;
                            context._completeHide(relatedTarget);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "dataApiKeydownHandler",
                value: function dataApiKeydownHandler(event) {
                    // If not an UP | DOWN | ESCAPE key => not a dropdown command
                    // If input/textarea && if key is other than ESCAPE => not a dropdown command
                    var isInput = /input|textarea/i.test(event.target.tagName);
                    var isEscapeEvent = event.key === ESCAPE_KEY$2;
                    var isUpOrDownEvent = [
                        ARROW_UP_KEY$1,
                        ARROW_DOWN_KEY$1
                    ].includes(event.key);
                    if (!isUpOrDownEvent && !isEscapeEvent) return;
                    if (isInput && !isEscapeEvent) return;
                    event.preventDefault();
                    // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
                    var getToggleButton = this.matches(SELECTOR_DATA_TOGGLE$3) ? this : SelectorEngine.prev(this, SELECTOR_DATA_TOGGLE$3)[0] || SelectorEngine.next(this, SELECTOR_DATA_TOGGLE$3)[0] || SelectorEngine.findOne(SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
                    var instance = Dropdown.getOrCreateInstance(getToggleButton);
                    if (isUpOrDownEvent) {
                        event.stopPropagation();
                        instance.show();
                        instance._selectMenuItem(event);
                        return;
                    }
                    if (instance._isShown()) {
                        // else is escape and we check if it is shown
                        event.stopPropagation();
                        instance.hide();
                        getToggleButton.focus();
                    }
                }
            }
        ]);
        return Dropdown;
    }(BaseComponent);
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$3, Dropdown.dataApiKeydownHandler);
    EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown.dataApiKeydownHandler);
    EventHandler.on(document, EVENT_CLICK_DATA_API$3, Dropdown.clearMenus);
    EventHandler.on(document, EVENT_KEYUP_DATA_API, Dropdown.clearMenus);
    EventHandler.on(document, EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$3, function(event) {
        event.preventDefault();
        Dropdown.getOrCreateInstance(this).toggle();
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Dropdown);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/backdrop.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var NAME$9 = 'backdrop';
    var CLASS_NAME_FADE$4 = 'fade';
    var CLASS_NAME_SHOW$5 = 'show';
    var EVENT_MOUSEDOWN = "mousedown.bs.".concat(NAME$9);
    var Default$8 = {
        className: 'modal-backdrop',
        clickCallback: null,
        isAnimated: false,
        isVisible: true,
        // if false, we use the backdrop helper without adding any element to the dom
        rootElement: 'body' // give the choice to place backdrop under different elements
    };
    var DefaultType$8 = {
        className: 'string',
        clickCallback: '(function|null)',
        isAnimated: 'boolean',
        isVisible: 'boolean',
        rootElement: '(element|string)'
    };
    /**
   * Class definition
   */ var Backdrop = /*#__PURE__*/ function(Config) {
        (0, $99c2e1b2c4a01e52$export$71511d61b312f219)(Backdrop, Config);
        function Backdrop(config) {
            (0, $369e92947825c2b5$export$71511d61b312f219)(this, Backdrop);
            var _this;
            _this = (0, $972025e4d4e45634$export$71511d61b312f219)(this, Backdrop);
            _this._config = _this._getConfig(config);
            _this._isAppended = false;
            _this._element = null;
            return _this;
        }
        (0, $11b219ef186b1c94$export$71511d61b312f219)(Backdrop, [
            {
                // Public
                key: "show",
                value: function show(callback) {
                    if (!this._config.isVisible) {
                        execute(callback);
                        return;
                    }
                    this._append();
                    var element = this._getElement();
                    if (this._config.isAnimated) reflow(element);
                    element.classList.add(CLASS_NAME_SHOW$5);
                    this._emulateAnimation(function() {
                        execute(callback);
                    });
                }
            },
            {
                key: "hide",
                value: function hide(callback) {
                    var _this = this;
                    if (!this._config.isVisible) {
                        execute(callback);
                        return;
                    }
                    this._getElement().classList.remove(CLASS_NAME_SHOW$5);
                    this._emulateAnimation(function() {
                        _this.dispose();
                        execute(callback);
                    });
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    if (!this._isAppended) return;
                    EventHandler.off(this._element, EVENT_MOUSEDOWN);
                    this._element.remove();
                    this._isAppended = false;
                }
            },
            {
                // Private
                key: "_getElement",
                value: function _getElement() {
                    if (!this._element) {
                        var backdrop = document.createElement('div');
                        backdrop.className = this._config.className;
                        if (this._config.isAnimated) backdrop.classList.add(CLASS_NAME_FADE$4);
                        this._element = backdrop;
                    }
                    return this._element;
                }
            },
            {
                key: "_configAfterMerge",
                value: function _configAfterMerge(config) {
                    // use getElement() with the default "body" to get a fresh Element on each instantiation
                    config.rootElement = getElement(config.rootElement);
                    return config;
                }
            },
            {
                key: "_append",
                value: function _append() {
                    var _this = this;
                    if (this._isAppended) return;
                    var element = this._getElement();
                    this._config.rootElement.append(element);
                    EventHandler.on(element, EVENT_MOUSEDOWN, function() {
                        execute(_this._config.clickCallback);
                    });
                    this._isAppended = true;
                }
            },
            {
                key: "_emulateAnimation",
                value: function _emulateAnimation(callback) {
                    executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
                }
            }
        ], [
            {
                key: "Default",
                get: // Getters
                function get() {
                    return Default$8;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$8;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$9;
                }
            }
        ]);
        return Backdrop;
    }(Config);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/focustrap.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var NAME$8 = 'focustrap';
    var DATA_KEY$5 = 'bs.focustrap';
    var EVENT_KEY$5 = ".".concat(DATA_KEY$5);
    var EVENT_FOCUSIN$2 = "focusin".concat(EVENT_KEY$5);
    var EVENT_KEYDOWN_TAB = "keydown.tab".concat(EVENT_KEY$5);
    var TAB_KEY = 'Tab';
    var TAB_NAV_FORWARD = 'forward';
    var TAB_NAV_BACKWARD = 'backward';
    var Default$7 = {
        autofocus: true,
        trapElement: null // The element to trap focus inside of
    };
    var DefaultType$7 = {
        autofocus: 'boolean',
        trapElement: 'element'
    };
    /**
   * Class definition
   */ var FocusTrap = /*#__PURE__*/ function(Config) {
        (0, $99c2e1b2c4a01e52$export$71511d61b312f219)(FocusTrap, Config);
        function FocusTrap(config) {
            (0, $369e92947825c2b5$export$71511d61b312f219)(this, FocusTrap);
            var _this;
            _this = (0, $972025e4d4e45634$export$71511d61b312f219)(this, FocusTrap);
            _this._config = _this._getConfig(config);
            _this._isActive = false;
            _this._lastTabNavDirection = null;
            return _this;
        }
        (0, $11b219ef186b1c94$export$71511d61b312f219)(FocusTrap, [
            {
                // Public
                key: "activate",
                value: function activate() {
                    var _this = this;
                    if (this._isActive) return;
                    if (this._config.autofocus) this._config.trapElement.focus();
                    EventHandler.off(document, EVENT_KEY$5); // guard against infinite focus loop
                    EventHandler.on(document, EVENT_FOCUSIN$2, function(event) {
                        return _this._handleFocusin(event);
                    });
                    EventHandler.on(document, EVENT_KEYDOWN_TAB, function(event) {
                        return _this._handleKeydown(event);
                    });
                    this._isActive = true;
                }
            },
            {
                key: "deactivate",
                value: function deactivate() {
                    if (!this._isActive) return;
                    this._isActive = false;
                    EventHandler.off(document, EVENT_KEY$5);
                }
            },
            {
                // Private
                key: "_handleFocusin",
                value: function _handleFocusin(event) {
                    var trapElement = this._config.trapElement;
                    if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
                    var elements = SelectorEngine.focusableChildren(trapElement);
                    if (elements.length === 0) trapElement.focus();
                    else if (this._lastTabNavDirection === TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
                    else elements[0].focus();
                }
            },
            {
                key: "_handleKeydown",
                value: function _handleKeydown(event) {
                    if (event.key !== TAB_KEY) return;
                    this._lastTabNavDirection = event.shiftKey ? TAB_NAV_BACKWARD : TAB_NAV_FORWARD;
                }
            }
        ], [
            {
                key: "Default",
                get: // Getters
                function get() {
                    return Default$7;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$7;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$8;
                }
            }
        ]);
        return FocusTrap;
    }(Config);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/scrollBar.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
    var SELECTOR_STICKY_CONTENT = '.sticky-top';
    var PROPERTY_PADDING = 'padding-right';
    var PROPERTY_MARGIN = 'margin-right';
    /**
   * Class definition
   */ var ScrollBarHelper = /*#__PURE__*/ function() {
        function ScrollBarHelper() {
            (0, $369e92947825c2b5$export$71511d61b312f219)(this, ScrollBarHelper);
            this._element = document.body;
        }
        (0, $11b219ef186b1c94$export$71511d61b312f219)(ScrollBarHelper, [
            {
                // Public
                key: "getWidth",
                value: function getWidth() {
                    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
                    var documentWidth = document.documentElement.clientWidth;
                    return Math.abs(window.innerWidth - documentWidth);
                }
            },
            {
                key: "hide",
                value: function hide() {
                    var width = this.getWidth();
                    this._disableOverFlow();
                    // give padding to element to balance the hidden scrollbar width
                    this._setElementAttributes(this._element, PROPERTY_PADDING, function(calculatedValue) {
                        return calculatedValue + width;
                    });
                    // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
                    this._setElementAttributes(SELECTOR_FIXED_CONTENT, PROPERTY_PADDING, function(calculatedValue) {
                        return calculatedValue + width;
                    });
                    this._setElementAttributes(SELECTOR_STICKY_CONTENT, PROPERTY_MARGIN, function(calculatedValue) {
                        return calculatedValue - width;
                    });
                }
            },
            {
                key: "reset",
                value: function reset() {
                    this._resetElementAttributes(this._element, 'overflow');
                    this._resetElementAttributes(this._element, PROPERTY_PADDING);
                    this._resetElementAttributes(SELECTOR_FIXED_CONTENT, PROPERTY_PADDING);
                    this._resetElementAttributes(SELECTOR_STICKY_CONTENT, PROPERTY_MARGIN);
                }
            },
            {
                key: "isOverflowing",
                value: function isOverflowing() {
                    return this.getWidth() > 0;
                }
            },
            {
                // Private
                key: "_disableOverFlow",
                value: function _disableOverFlow() {
                    this._saveInitialAttribute(this._element, 'overflow');
                    this._element.style.overflow = 'hidden';
                }
            },
            {
                key: "_setElementAttributes",
                value: function _setElementAttributes(selector, styleProperty, callback) {
                    var _this = this;
                    var scrollbarWidth = this.getWidth();
                    var manipulationCallBack = function(element) {
                        if (element !== _this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
                        _this._saveInitialAttribute(element, styleProperty);
                        var calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
                        element.style.setProperty(styleProperty, "".concat(callback(Number.parseFloat(calculatedValue)), "px"));
                    };
                    this._applyManipulationCallback(selector, manipulationCallBack);
                }
            },
            {
                key: "_saveInitialAttribute",
                value: function _saveInitialAttribute(element, styleProperty) {
                    var actualValue = element.style.getPropertyValue(styleProperty);
                    if (actualValue) Manipulator.setDataAttribute(element, styleProperty, actualValue);
                }
            },
            {
                key: "_resetElementAttributes",
                value: function _resetElementAttributes(selector, styleProperty) {
                    var manipulationCallBack = function(element) {
                        var value = Manipulator.getDataAttribute(element, styleProperty);
                        // We only want to remove the property if the value is `null`; the value can also be zero
                        if (value === null) {
                            element.style.removeProperty(styleProperty);
                            return;
                        }
                        Manipulator.removeDataAttribute(element, styleProperty);
                        element.style.setProperty(styleProperty, value);
                    };
                    this._applyManipulationCallback(selector, manipulationCallBack);
                }
            },
            {
                key: "_applyManipulationCallback",
                value: function _applyManipulationCallback(selector, callBack) {
                    if (isElement$1(selector)) {
                        callBack(selector);
                        return;
                    }
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = SelectorEngine.find(selector, this._element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var sel = _step.value;
                            callBack(sel);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        ]);
        return ScrollBarHelper;
    }();
    /**
   * --------------------------------------------------------------------------
   * Bootstrap modal.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var NAME$7 = 'modal';
    var DATA_KEY$4 = 'bs.modal';
    var EVENT_KEY$4 = ".".concat(DATA_KEY$4);
    var DATA_API_KEY$2 = '.data-api';
    var ESCAPE_KEY$1 = 'Escape';
    var EVENT_HIDE$4 = "hide".concat(EVENT_KEY$4);
    var EVENT_HIDE_PREVENTED$1 = "hidePrevented".concat(EVENT_KEY$4);
    var EVENT_HIDDEN$4 = "hidden".concat(EVENT_KEY$4);
    var EVENT_SHOW$4 = "show".concat(EVENT_KEY$4);
    var EVENT_SHOWN$4 = "shown".concat(EVENT_KEY$4);
    var EVENT_RESIZE$1 = "resize".concat(EVENT_KEY$4);
    var EVENT_CLICK_DISMISS = "click.dismiss".concat(EVENT_KEY$4);
    var EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss".concat(EVENT_KEY$4);
    var EVENT_KEYDOWN_DISMISS$1 = "keydown.dismiss".concat(EVENT_KEY$4);
    var EVENT_CLICK_DATA_API$2 = "click".concat(EVENT_KEY$4).concat(DATA_API_KEY$2);
    var CLASS_NAME_OPEN = 'modal-open';
    var CLASS_NAME_FADE$3 = 'fade';
    var CLASS_NAME_SHOW$4 = 'show';
    var CLASS_NAME_STATIC = 'modal-static';
    var OPEN_SELECTOR$1 = '.modal.show';
    var SELECTOR_DIALOG = '.modal-dialog';
    var SELECTOR_MODAL_BODY = '.modal-body';
    var SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
    var Default$6 = {
        backdrop: true,
        focus: true,
        keyboard: true
    };
    var DefaultType$6 = {
        backdrop: '(boolean|string)',
        focus: 'boolean',
        keyboard: 'boolean'
    };
    /**
   * Class definition
   */ var Modal = /*#__PURE__*/ function(BaseComponent) {
        (0, $99c2e1b2c4a01e52$export$71511d61b312f219)(Modal, BaseComponent);
        function Modal(element, config) {
            (0, $369e92947825c2b5$export$71511d61b312f219)(this, Modal);
            var _this;
            _this = (0, $972025e4d4e45634$export$71511d61b312f219)(this, Modal, [
                element,
                config
            ]);
            _this._dialog = SelectorEngine.findOne(SELECTOR_DIALOG, _this._element);
            _this._backdrop = _this._initializeBackDrop();
            _this._focustrap = _this._initializeFocusTrap();
            _this._isShown = false;
            _this._isTransitioning = false;
            _this._scrollBar = new ScrollBarHelper();
            _this._addEventListeners();
            return _this;
        }
        (0, $11b219ef186b1c94$export$71511d61b312f219)(Modal, [
            {
                // Public
                key: "toggle",
                value: function toggle(relatedTarget) {
                    return this._isShown ? this.hide() : this.show(relatedTarget);
                }
            },
            {
                key: "show",
                value: function show(relatedTarget) {
                    var _this = this;
                    if (this._isShown || this._isTransitioning) return;
                    var showEvent = EventHandler.trigger(this._element, EVENT_SHOW$4, {
                        relatedTarget: relatedTarget
                    });
                    if (showEvent.defaultPrevented) return;
                    this._isShown = true;
                    this._isTransitioning = true;
                    this._scrollBar.hide();
                    document.body.classList.add(CLASS_NAME_OPEN);
                    this._adjustDialog();
                    this._backdrop.show(function() {
                        return _this._showElement(relatedTarget);
                    });
                }
            },
            {
                key: "hide",
                value: function hide() {
                    var _this = this;
                    if (!this._isShown || this._isTransitioning) return;
                    var hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$4);
                    if (hideEvent.defaultPrevented) return;
                    this._isShown = false;
                    this._isTransitioning = true;
                    this._focustrap.deactivate();
                    this._element.classList.remove(CLASS_NAME_SHOW$4);
                    this._queueCallback(function() {
                        return _this._hideModal();
                    }, this._element, this._isAnimated());
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    EventHandler.off(window, EVENT_KEY$4);
                    EventHandler.off(this._dialog, EVENT_KEY$4);
                    this._backdrop.dispose();
                    this._focustrap.deactivate();
                    (0, $00e9f136d8b86c33$export$71511d61b312f219)((0, $81c9c858187986cb$export$71511d61b312f219)(Modal.prototype), "dispose", this).call(this);
                }
            },
            {
                key: "handleUpdate",
                value: function handleUpdate() {
                    this._adjustDialog();
                }
            },
            {
                // Private
                key: "_initializeBackDrop",
                value: function _initializeBackDrop() {
                    return new Backdrop({
                        isVisible: Boolean(this._config.backdrop),
                        // 'static' option will be translated to true, and booleans will keep their value,
                        isAnimated: this._isAnimated()
                    });
                }
            },
            {
                key: "_initializeFocusTrap",
                value: function _initializeFocusTrap() {
                    return new FocusTrap({
                        trapElement: this._element
                    });
                }
            },
            {
                key: "_showElement",
                value: function _showElement(relatedTarget) {
                    var _this = this;
                    // try to append dynamic modal
                    if (!document.body.contains(this._element)) document.body.append(this._element);
                    this._element.style.display = 'block';
                    this._element.removeAttribute('aria-hidden');
                    this._element.setAttribute('aria-modal', true);
                    this._element.setAttribute('role', 'dialog');
                    this._element.scrollTop = 0;
                    var modalBody = SelectorEngine.findOne(SELECTOR_MODAL_BODY, this._dialog);
                    if (modalBody) modalBody.scrollTop = 0;
                    reflow(this._element);
                    this._element.classList.add(CLASS_NAME_SHOW$4);
                    var transitionComplete = function() {
                        if (_this._config.focus) _this._focustrap.activate();
                        _this._isTransitioning = false;
                        EventHandler.trigger(_this._element, EVENT_SHOWN$4, {
                            relatedTarget: relatedTarget
                        });
                    };
                    this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
                }
            },
            {
                key: "_addEventListeners",
                value: function _addEventListeners() {
                    var _this = this;
                    EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS$1, function(event) {
                        if (event.key !== ESCAPE_KEY$1) return;
                        if (_this._config.keyboard) {
                            _this.hide();
                            return;
                        }
                        _this._triggerBackdropTransition();
                    });
                    EventHandler.on(window, EVENT_RESIZE$1, function() {
                        if (_this._isShown && !_this._isTransitioning) _this._adjustDialog();
                    });
                    EventHandler.on(this._element, EVENT_MOUSEDOWN_DISMISS, function(event) {
                        // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
                        EventHandler.one(_this._element, EVENT_CLICK_DISMISS, function(event2) {
                            if (_this._element !== event.target || _this._element !== event2.target) return;
                            if (_this._config.backdrop === 'static') {
                                _this._triggerBackdropTransition();
                                return;
                            }
                            if (_this._config.backdrop) _this.hide();
                        });
                    });
                }
            },
            {
                key: "_hideModal",
                value: function _hideModal() {
                    var _this = this;
                    this._element.style.display = 'none';
                    this._element.setAttribute('aria-hidden', true);
                    this._element.removeAttribute('aria-modal');
                    this._element.removeAttribute('role');
                    this._isTransitioning = false;
                    this._backdrop.hide(function() {
                        document.body.classList.remove(CLASS_NAME_OPEN);
                        _this._resetAdjustments();
                        _this._scrollBar.reset();
                        EventHandler.trigger(_this._element, EVENT_HIDDEN$4);
                    });
                }
            },
            {
                key: "_isAnimated",
                value: function _isAnimated() {
                    return this._element.classList.contains(CLASS_NAME_FADE$3);
                }
            },
            {
                key: "_triggerBackdropTransition",
                value: function _triggerBackdropTransition() {
                    var _this = this;
                    var hideEvent = EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED$1);
                    if (hideEvent.defaultPrevented) return;
                    var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
                    var initialOverflowY = this._element.style.overflowY;
                    // return if the following background transition hasn't yet completed
                    if (initialOverflowY === 'hidden' || this._element.classList.contains(CLASS_NAME_STATIC)) return;
                    if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
                    this._element.classList.add(CLASS_NAME_STATIC);
                    this._queueCallback(function() {
                        _this._element.classList.remove(CLASS_NAME_STATIC);
                        _this._queueCallback(function() {
                            _this._element.style.overflowY = initialOverflowY;
                        }, _this._dialog);
                    }, this._dialog);
                    this._element.focus();
                }
            },
            {
                /**
     * The following methods are used to handle overflowing modals
     */ key: "_adjustDialog",
                value: function _adjustDialog() {
                    var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
                    var scrollbarWidth = this._scrollBar.getWidth();
                    var isBodyOverflowing = scrollbarWidth > 0;
                    if (isBodyOverflowing && !isModalOverflowing) {
                        var property = isRTL() ? 'paddingLeft' : 'paddingRight';
                        this._element.style[property] = "".concat(scrollbarWidth, "px");
                    }
                    if (!isBodyOverflowing && isModalOverflowing) {
                        var property1 = isRTL() ? 'paddingRight' : 'paddingLeft';
                        this._element.style[property1] = "".concat(scrollbarWidth, "px");
                    }
                }
            },
            {
                key: "_resetAdjustments",
                value: function _resetAdjustments() {
                    this._element.style.paddingLeft = '';
                    this._element.style.paddingRight = '';
                }
            }
        ], [
            {
                key: "Default",
                get: // Getters
                function get() {
                    return Default$6;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$6;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$7;
                }
            },
            {
                key: "jQueryInterface",
                value: // Static
                function jQueryInterface(config, relatedTarget) {
                    return this.each(function() {
                        var data = Modal.getOrCreateInstance(this, config);
                        if (typeof config !== 'string') return;
                        if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config](relatedTarget);
                    });
                }
            }
        ]);
        return Modal;
    }(BaseComponent);
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$2, SELECTOR_DATA_TOGGLE$2, function(event) {
        var _this = this;
        var target = SelectorEngine.getElementFromSelector(this);
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        EventHandler.one(target, EVENT_SHOW$4, function(showEvent) {
            if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
            return;
            EventHandler.one(target, EVENT_HIDDEN$4, function() {
                if (isVisible(_this)) _this.focus();
            });
        });
        // avoid conflict when clicking modal toggler while another one is open
        var alreadyOpen = SelectorEngine.findOne(OPEN_SELECTOR$1);
        if (alreadyOpen) Modal.getInstance(alreadyOpen).hide();
        var data = Modal.getOrCreateInstance(target);
        data.toggle(this);
    });
    enableDismissTrigger(Modal);
    /**
   * jQuery
   */ defineJQueryPlugin(Modal);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap offcanvas.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var NAME$6 = 'offcanvas';
    var DATA_KEY$3 = 'bs.offcanvas';
    var EVENT_KEY$3 = ".".concat(DATA_KEY$3);
    var DATA_API_KEY$1 = '.data-api';
    var EVENT_LOAD_DATA_API$2 = "load".concat(EVENT_KEY$3).concat(DATA_API_KEY$1);
    var ESCAPE_KEY = 'Escape';
    var CLASS_NAME_SHOW$3 = 'show';
    var CLASS_NAME_SHOWING$1 = 'showing';
    var CLASS_NAME_HIDING = 'hiding';
    var CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
    var OPEN_SELECTOR = '.offcanvas.show';
    var EVENT_SHOW$3 = "show".concat(EVENT_KEY$3);
    var EVENT_SHOWN$3 = "shown".concat(EVENT_KEY$3);
    var EVENT_HIDE$3 = "hide".concat(EVENT_KEY$3);
    var EVENT_HIDE_PREVENTED = "hidePrevented".concat(EVENT_KEY$3);
    var EVENT_HIDDEN$3 = "hidden".concat(EVENT_KEY$3);
    var EVENT_RESIZE = "resize".concat(EVENT_KEY$3);
    var EVENT_CLICK_DATA_API$1 = "click".concat(EVENT_KEY$3).concat(DATA_API_KEY$1);
    var EVENT_KEYDOWN_DISMISS = "keydown.dismiss".concat(EVENT_KEY$3);
    var SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
    var Default$5 = {
        backdrop: true,
        keyboard: true,
        scroll: false
    };
    var DefaultType$5 = {
        backdrop: '(boolean|string)',
        keyboard: 'boolean',
        scroll: 'boolean'
    };
    /**
   * Class definition
   */ var Offcanvas = /*#__PURE__*/ function(BaseComponent) {
        (0, $99c2e1b2c4a01e52$export$71511d61b312f219)(Offcanvas, BaseComponent);
        function Offcanvas(element, config) {
            (0, $369e92947825c2b5$export$71511d61b312f219)(this, Offcanvas);
            var _this;
            _this = (0, $972025e4d4e45634$export$71511d61b312f219)(this, Offcanvas, [
                element,
                config
            ]);
            _this._isShown = false;
            _this._backdrop = _this._initializeBackDrop();
            _this._focustrap = _this._initializeFocusTrap();
            _this._addEventListeners();
            return _this;
        }
        (0, $11b219ef186b1c94$export$71511d61b312f219)(Offcanvas, [
            {
                // Public
                key: "toggle",
                value: function toggle(relatedTarget) {
                    return this._isShown ? this.hide() : this.show(relatedTarget);
                }
            },
            {
                key: "show",
                value: function show(relatedTarget) {
                    var _this = this;
                    if (this._isShown) return;
                    var showEvent = EventHandler.trigger(this._element, EVENT_SHOW$3, {
                        relatedTarget: relatedTarget
                    });
                    if (showEvent.defaultPrevented) return;
                    this._isShown = true;
                    this._backdrop.show();
                    if (!this._config.scroll) new ScrollBarHelper().hide();
                    this._element.setAttribute('aria-modal', true);
                    this._element.setAttribute('role', 'dialog');
                    this._element.classList.add(CLASS_NAME_SHOWING$1);
                    var completeCallBack = function() {
                        if (!_this._config.scroll || _this._config.backdrop) _this._focustrap.activate();
                        _this._element.classList.add(CLASS_NAME_SHOW$3);
                        _this._element.classList.remove(CLASS_NAME_SHOWING$1);
                        EventHandler.trigger(_this._element, EVENT_SHOWN$3, {
                            relatedTarget: relatedTarget
                        });
                    };
                    this._queueCallback(completeCallBack, this._element, true);
                }
            },
            {
                key: "hide",
                value: function hide() {
                    var _this = this;
                    if (!this._isShown) return;
                    var hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$3);
                    if (hideEvent.defaultPrevented) return;
                    this._focustrap.deactivate();
                    this._element.blur();
                    this._isShown = false;
                    this._element.classList.add(CLASS_NAME_HIDING);
                    this._backdrop.hide();
                    var completeCallback = function() {
                        _this._element.classList.remove(CLASS_NAME_SHOW$3, CLASS_NAME_HIDING);
                        _this._element.removeAttribute('aria-modal');
                        _this._element.removeAttribute('role');
                        if (!_this._config.scroll) new ScrollBarHelper().reset();
                        EventHandler.trigger(_this._element, EVENT_HIDDEN$3);
                    };
                    this._queueCallback(completeCallback, this._element, true);
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    this._backdrop.dispose();
                    this._focustrap.deactivate();
                    (0, $00e9f136d8b86c33$export$71511d61b312f219)((0, $81c9c858187986cb$export$71511d61b312f219)(Offcanvas.prototype), "dispose", this).call(this);
                }
            },
            {
                // Private
                key: "_initializeBackDrop",
                value: function _initializeBackDrop() {
                    var _this = this;
                    var clickCallback = function() {
                        if (_this._config.backdrop === 'static') {
                            EventHandler.trigger(_this._element, EVENT_HIDE_PREVENTED);
                            return;
                        }
                        _this.hide();
                    };
                    // 'static' option will be translated to true, and booleans will keep their value
                    var isVisible = Boolean(this._config.backdrop);
                    return new Backdrop({
                        className: CLASS_NAME_BACKDROP,
                        isVisible: isVisible,
                        isAnimated: true,
                        rootElement: this._element.parentNode,
                        clickCallback: isVisible ? clickCallback : null
                    });
                }
            },
            {
                key: "_initializeFocusTrap",
                value: function _initializeFocusTrap() {
                    return new FocusTrap({
                        trapElement: this._element
                    });
                }
            },
            {
                key: "_addEventListeners",
                value: function _addEventListeners() {
                    var _this = this;
                    EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS, function(event) {
                        if (event.key !== ESCAPE_KEY) return;
                        if (_this._config.keyboard) {
                            _this.hide();
                            return;
                        }
                        EventHandler.trigger(_this._element, EVENT_HIDE_PREVENTED);
                    });
                }
            }
        ], [
            {
                key: "Default",
                get: // Getters
                function get() {
                    return Default$5;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$5;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$6;
                }
            },
            {
                key: "jQueryInterface",
                value: // Static
                function jQueryInterface(config) {
                    return this.each(function() {
                        var data = Offcanvas.getOrCreateInstance(this, config);
                        if (typeof config !== 'string') return;
                        if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config](this);
                    });
                }
            }
        ]);
        return Offcanvas;
    }(BaseComponent);
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE$1, function(event) {
        var _this = this;
        var target = SelectorEngine.getElementFromSelector(this);
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if (isDisabled(this)) return;
        EventHandler.one(target, EVENT_HIDDEN$3, function() {
            // focus on trigger when it is closed
            if (isVisible(_this)) _this.focus();
        });
        // avoid conflict when clicking a toggler of an offcanvas, while another is open
        var alreadyOpen = SelectorEngine.findOne(OPEN_SELECTOR);
        if (alreadyOpen && alreadyOpen !== target) Offcanvas.getInstance(alreadyOpen).hide();
        var data = Offcanvas.getOrCreateInstance(target);
        data.toggle(this);
    });
    EventHandler.on(window, EVENT_LOAD_DATA_API$2, function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = SelectorEngine.find(OPEN_SELECTOR)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var selector = _step.value;
                Offcanvas.getOrCreateInstance(selector).show();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    EventHandler.on(window, EVENT_RESIZE, function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                if (getComputedStyle(element).position !== 'fixed') Offcanvas.getOrCreateInstance(element).hide();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    enableDismissTrigger(Offcanvas);
    /**
   * jQuery
   */ defineJQueryPlugin(Offcanvas);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/sanitizer.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ // js-docs-start allow-list
    var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
    var DefaultAllowlist = {
        // Global attributes allowed on any supplied element below.
        '*': [
            'class',
            'dir',
            'id',
            'lang',
            'role',
            ARIA_ATTRIBUTE_PATTERN
        ],
        a: [
            'target',
            'href',
            'title',
            'rel'
        ],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        dd: [],
        div: [],
        dl: [],
        dt: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: [
            'src',
            'srcset',
            'alt',
            'title',
            'width',
            'height'
        ],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: []
    };
    // js-docs-end allow-list
    var uriAttributes = new Set([
        'background',
        'cite',
        'href',
        'itemtype',
        'longdesc',
        'poster',
        'src',
        'xlink:href'
    ]);
    /**
   * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
   * contexts.
   *
   * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
   */ var SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
    var allowedAttribute = function(attribute, allowedAttributeList) {
        var attributeName = attribute.nodeName.toLowerCase();
        if (allowedAttributeList.includes(attributeName)) {
            if (uriAttributes.has(attributeName)) return Boolean(SAFE_URL_PATTERN.test(attribute.nodeValue));
            return true;
        }
        // Check if a regular expression validates the attribute.
        return allowedAttributeList.filter(function(attributeRegex) {
            return attributeRegex instanceof RegExp;
        }).some(function(regex) {
            return regex.test(attributeName);
        });
    };
    function sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
        var _instance;
        if (!unsafeHtml.length) return unsafeHtml;
        if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
        var domParser = new window.DOMParser();
        var createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
        var elements = (_instance = []).concat.apply(_instance, (0, $8d1416c8f734345e$export$71511d61b312f219)(createdDocument.body.querySelectorAll('*')));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                var _instance1;
                var elementName = element.nodeName.toLowerCase();
                if (!Object.keys(allowList).includes(elementName)) {
                    element.remove();
                    continue;
                }
                var attributeList = (_instance1 = []).concat.apply(_instance1, (0, $8d1416c8f734345e$export$71511d61b312f219)(element.attributes));
                var allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = attributeList[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var attribute = _step1.value;
                        if (!allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return createdDocument.body.innerHTML;
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/template-factory.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var NAME$5 = 'TemplateFactory';
    var Default$4 = {
        allowList: DefaultAllowlist,
        content: {},
        // { selector : text ,  selector2 : text2 , }
        extraClass: '',
        html: false,
        sanitize: true,
        sanitizeFn: null,
        template: '<div></div>'
    };
    var DefaultType$4 = {
        allowList: 'object',
        content: 'object',
        extraClass: '(string|function)',
        html: 'boolean',
        sanitize: 'boolean',
        sanitizeFn: '(null|function)',
        template: 'string'
    };
    var DefaultContentType = {
        entry: '(string|element|function|null)',
        selector: '(string|element)'
    };
    /**
   * Class definition
   */ var TemplateFactory = /*#__PURE__*/ function(Config) {
        (0, $99c2e1b2c4a01e52$export$71511d61b312f219)(TemplateFactory, Config);
        function TemplateFactory(config) {
            (0, $369e92947825c2b5$export$71511d61b312f219)(this, TemplateFactory);
            var _this;
            _this = (0, $972025e4d4e45634$export$71511d61b312f219)(this, TemplateFactory);
            _this._config = _this._getConfig(config);
            return _this;
        }
        (0, $11b219ef186b1c94$export$71511d61b312f219)(TemplateFactory, [
            {
                // Public
                key: "getContent",
                value: function getContent() {
                    var _this = this;
                    return Object.values(this._config.content).map(function(config) {
                        return _this._resolvePossibleFunction(config);
                    }).filter(Boolean);
                }
            },
            {
                key: "hasContent",
                value: function hasContent() {
                    return this.getContent().length > 0;
                }
            },
            {
                key: "changeContent",
                value: function changeContent(content) {
                    this._checkContent(content);
                    this._config.content = (0, $9bf4d105a019f48b$export$71511d61b312f219)({}, this._config.content, content);
                    return this;
                }
            },
            {
                key: "toHtml",
                value: function toHtml() {
                    var _template_classList;
                    var templateWrapper = document.createElement('div');
                    templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(this._config.content)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $91a007218046315e$export$71511d61b312f219)(_step.value, 2), selector = _step_value[0], text = _step_value[1];
                            this._setContent(templateWrapper, text, selector);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var template = templateWrapper.children[0];
                    var extraClass = this._resolvePossibleFunction(this._config.extraClass);
                    if (extraClass) (_template_classList = template.classList).add.apply(_template_classList, (0, $8d1416c8f734345e$export$71511d61b312f219)(extraClass.split(' ')));
                    return template;
                }
            },
            {
                // Private
                key: "_typeCheckConfig",
                value: function _typeCheckConfig(config) {
                    (0, $00e9f136d8b86c33$export$71511d61b312f219)((0, $81c9c858187986cb$export$71511d61b312f219)(TemplateFactory.prototype), "_typeCheckConfig", this).call(this, config);
                    this._checkContent(config.content);
                }
            },
            {
                key: "_checkContent",
                value: function _checkContent(arg) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(arg)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $91a007218046315e$export$71511d61b312f219)(_step.value, 2), selector = _step_value[0], content = _step_value[1];
                            (0, $00e9f136d8b86c33$export$71511d61b312f219)((0, $81c9c858187986cb$export$71511d61b312f219)(TemplateFactory.prototype), "_typeCheckConfig", this).call(this, {
                                selector: selector,
                                entry: content
                            }, DefaultContentType);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "_setContent",
                value: function _setContent(template, content, selector) {
                    var templateElement = SelectorEngine.findOne(selector, template);
                    if (!templateElement) return;
                    content = this._resolvePossibleFunction(content);
                    if (!content) {
                        templateElement.remove();
                        return;
                    }
                    if (isElement$1(content)) {
                        this._putElementInTemplate(getElement(content), templateElement);
                        return;
                    }
                    if (this._config.html) {
                        templateElement.innerHTML = this._maybeSanitize(content);
                        return;
                    }
                    templateElement.textContent = content;
                }
            },
            {
                key: "_maybeSanitize",
                value: function _maybeSanitize(arg) {
                    return this._config.sanitize ? sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
                }
            },
            {
                key: "_resolvePossibleFunction",
                value: function _resolvePossibleFunction(arg) {
                    return execute(arg, [
                        undefined,
                        this
                    ]);
                }
            },
            {
                key: "_putElementInTemplate",
                value: function _putElementInTemplate(element, templateElement) {
                    if (this._config.html) {
                        templateElement.innerHTML = '';
                        templateElement.append(element);
                        return;
                    }
                    templateElement.textContent = element.textContent;
                }
            }
        ], [
            {
                key: "Default",
                get: // Getters
                function get() {
                    return Default$4;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$4;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$5;
                }
            }
        ]);
        return TemplateFactory;
    }(Config);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap tooltip.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var NAME$4 = 'tooltip';
    var DISALLOWED_ATTRIBUTES = new Set([
        'sanitize',
        'allowList',
        'sanitizeFn'
    ]);
    var CLASS_NAME_FADE$2 = 'fade';
    var CLASS_NAME_MODAL = 'modal';
    var CLASS_NAME_SHOW$2 = 'show';
    var SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
    var SELECTOR_MODAL = ".".concat(CLASS_NAME_MODAL);
    var EVENT_MODAL_HIDE = 'hide.bs.modal';
    var TRIGGER_HOVER = 'hover';
    var TRIGGER_FOCUS = 'focus';
    var TRIGGER_CLICK = 'click';
    var TRIGGER_MANUAL = 'manual';
    var EVENT_HIDE$2 = 'hide';
    var EVENT_HIDDEN$2 = 'hidden';
    var EVENT_SHOW$2 = 'show';
    var EVENT_SHOWN$2 = 'shown';
    var EVENT_INSERTED = 'inserted';
    var EVENT_CLICK$1 = 'click';
    var EVENT_FOCUSIN$1 = 'focusin';
    var EVENT_FOCUSOUT$1 = 'focusout';
    var EVENT_MOUSEENTER = 'mouseenter';
    var EVENT_MOUSELEAVE = 'mouseleave';
    var AttachmentMap = {
        AUTO: 'auto',
        TOP: 'top',
        RIGHT: isRTL() ? 'left' : 'right',
        BOTTOM: 'bottom',
        LEFT: isRTL() ? 'right' : 'left'
    };
    var Default$3 = {
        allowList: DefaultAllowlist,
        animation: true,
        boundary: 'clippingParents',
        container: false,
        customClass: '',
        delay: 0,
        fallbackPlacements: [
            'top',
            'right',
            'bottom',
            'left'
        ],
        html: false,
        offset: [
            0,
            6
        ],
        placement: 'top',
        popperConfig: null,
        sanitize: true,
        sanitizeFn: null,
        selector: false,
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        title: '',
        trigger: 'hover focus'
    };
    var DefaultType$3 = {
        allowList: 'object',
        animation: 'boolean',
        boundary: '(string|element)',
        container: '(string|element|boolean)',
        customClass: '(string|function)',
        delay: '(number|object)',
        fallbackPlacements: 'array',
        html: 'boolean',
        offset: '(array|string|function)',
        placement: '(string|function)',
        popperConfig: '(null|object|function)',
        sanitize: 'boolean',
        sanitizeFn: '(null|function)',
        selector: '(string|boolean)',
        template: 'string',
        title: '(string|element|function)',
        trigger: 'string'
    };
    /**
   * Class definition
   */ var Tooltip = /*#__PURE__*/ function(BaseComponent) {
        (0, $99c2e1b2c4a01e52$export$71511d61b312f219)(Tooltip, BaseComponent);
        function Tooltip(element, config) {
            (0, $369e92947825c2b5$export$71511d61b312f219)(this, Tooltip);
            var _this;
            if (typeof Popper === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
            _this = (0, $972025e4d4e45634$export$71511d61b312f219)(this, Tooltip, [
                element,
                config
            ]);
            // Private
            _this._isEnabled = true;
            _this._timeout = 0;
            _this._isHovered = null;
            _this._activeTrigger = {};
            _this._popper = null;
            _this._templateFactory = null;
            _this._newContent = null;
            // Protected
            _this.tip = null;
            _this._setListeners();
            if (!_this._config.selector) _this._fixTitle();
            return _this;
        }
        (0, $11b219ef186b1c94$export$71511d61b312f219)(Tooltip, [
            {
                // Public
                key: "enable",
                value: function enable() {
                    this._isEnabled = true;
                }
            },
            {
                key: "disable",
                value: function disable() {
                    this._isEnabled = false;
                }
            },
            {
                key: "toggleEnabled",
                value: function toggleEnabled() {
                    this._isEnabled = !this._isEnabled;
                }
            },
            {
                key: "toggle",
                value: function toggle() {
                    if (!this._isEnabled) return;
                    if (this._isShown()) {
                        this._leave();
                        return;
                    }
                    this._enter();
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    clearTimeout(this._timeout);
                    EventHandler.off(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);
                    if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
                    this._disposePopper();
                    (0, $00e9f136d8b86c33$export$71511d61b312f219)((0, $81c9c858187986cb$export$71511d61b312f219)(Tooltip.prototype), "dispose", this).call(this);
                }
            },
            {
                key: "show",
                value: function show() {
                    var _this = this;
                    var _instance;
                    if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
                    if (!(this._isWithContent() && this._isEnabled)) return;
                    var showEvent = EventHandler.trigger(this._element, this.constructor.eventName(EVENT_SHOW$2));
                    var shadowRoot = findShadowRoot(this._element);
                    var isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
                    if (showEvent.defaultPrevented || !isInTheDom) return;
                    // TODO: v6 remove this or make it optional
                    this._disposePopper();
                    var tip = this._getTipElement();
                    this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
                    var container = this._config.container;
                    if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
                        container.append(tip);
                        EventHandler.trigger(this._element, this.constructor.eventName(EVENT_INSERTED));
                    }
                    this._popper = this._createPopper(tip);
                    tip.classList.add(CLASS_NAME_SHOW$2);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    // If this is a touch-enabled device we add extra
                    // empty mouseover listeners to the body's immediate children;
                    // only needed because of broken event delegation on iOS
                    // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                    if ('ontouchstart' in document.documentElement) try {
                        for(var _iterator = (_instance = []).concat.apply(_instance, (0, $8d1416c8f734345e$export$71511d61b312f219)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            EventHandler.on(element, 'mouseover', noop);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var complete = function() {
                        EventHandler.trigger(_this._element, _this.constructor.eventName(EVENT_SHOWN$2));
                        if (_this._isHovered === false) _this._leave();
                        _this._isHovered = false;
                    };
                    this._queueCallback(complete, this.tip, this._isAnimated());
                }
            },
            {
                key: "hide",
                value: function hide() {
                    var _this = this;
                    var _instance;
                    if (!this._isShown()) return;
                    var hideEvent = EventHandler.trigger(this._element, this.constructor.eventName(EVENT_HIDE$2));
                    if (hideEvent.defaultPrevented) return;
                    var tip = this._getTipElement();
                    tip.classList.remove(CLASS_NAME_SHOW$2);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    // If this is a touch-enabled device we remove the extra
                    // empty mouseover listeners we added for iOS support
                    if ('ontouchstart' in document.documentElement) try {
                        for(var _iterator = (_instance = []).concat.apply(_instance, (0, $8d1416c8f734345e$export$71511d61b312f219)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            EventHandler.off(element, 'mouseover', noop);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this._activeTrigger[TRIGGER_CLICK] = false;
                    this._activeTrigger[TRIGGER_FOCUS] = false;
                    this._activeTrigger[TRIGGER_HOVER] = false;
                    this._isHovered = null; // it is a trick to support manual triggering
                    var complete = function() {
                        if (_this._isWithActiveTrigger()) return;
                        if (!_this._isHovered) _this._disposePopper();
                        _this._element.removeAttribute('aria-describedby');
                        EventHandler.trigger(_this._element, _this.constructor.eventName(EVENT_HIDDEN$2));
                    };
                    this._queueCallback(complete, this.tip, this._isAnimated());
                }
            },
            {
                key: "update",
                value: function update() {
                    if (this._popper) this._popper.update();
                }
            },
            {
                // Protected
                key: "_isWithContent",
                value: function _isWithContent() {
                    return Boolean(this._getTitle());
                }
            },
            {
                key: "_getTipElement",
                value: function _getTipElement() {
                    if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
                    return this.tip;
                }
            },
            {
                key: "_createTipElement",
                value: function _createTipElement(content) {
                    var tip = this._getTemplateFactory(content).toHtml();
                    // TODO: remove this check in v6
                    if (!tip) return null;
                    tip.classList.remove(CLASS_NAME_FADE$2, CLASS_NAME_SHOW$2);
                    // TODO: v6 the following can be achieved with CSS only
                    tip.classList.add("bs-".concat(this.constructor.NAME, "-auto"));
                    var tipId = getUID(this.constructor.NAME).toString();
                    tip.setAttribute('id', tipId);
                    if (this._isAnimated()) tip.classList.add(CLASS_NAME_FADE$2);
                    return tip;
                }
            },
            {
                key: "setContent",
                value: function setContent(content) {
                    this._newContent = content;
                    if (this._isShown()) {
                        this._disposePopper();
                        this.show();
                    }
                }
            },
            {
                key: "_getTemplateFactory",
                value: function _getTemplateFactory(content) {
                    if (this._templateFactory) this._templateFactory.changeContent(content);
                    else this._templateFactory = new TemplateFactory((0, $92079f442e5d1061$export$71511d61b312f219)((0, $9bf4d105a019f48b$export$71511d61b312f219)({}, this._config), {
                        // the `content` var has to be after `this._config`
                        // to override config.content in case of popover
                        content: content,
                        extraClass: this._resolvePossibleFunction(this._config.customClass)
                    }));
                    return this._templateFactory;
                }
            },
            {
                key: "_getContentForTemplate",
                value: function _getContentForTemplate() {
                    return (0, $28557b013f37bb6b$export$71511d61b312f219)({}, SELECTOR_TOOLTIP_INNER, this._getTitle());
                }
            },
            {
                key: "_getTitle",
                value: function _getTitle() {
                    return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
                }
            },
            {
                // Private
                key: "_initializeOnDelegatedTarget",
                value: function _initializeOnDelegatedTarget(event) {
                    return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
                }
            },
            {
                key: "_isAnimated",
                value: function _isAnimated() {
                    return this._config.animation || this.tip && this.tip.classList.contains(CLASS_NAME_FADE$2);
                }
            },
            {
                key: "_isShown",
                value: function _isShown() {
                    return this.tip && this.tip.classList.contains(CLASS_NAME_SHOW$2);
                }
            },
            {
                key: "_createPopper",
                value: function _createPopper(tip) {
                    var placement = execute(this._config.placement, [
                        this,
                        tip,
                        this._element
                    ]);
                    var attachment = AttachmentMap[placement.toUpperCase()];
                    return createPopper(this._element, tip, this._getPopperConfig(attachment));
                }
            },
            {
                key: "_getOffset",
                value: function _getOffset() {
                    var _this = this;
                    var _$offset = this._config.offset;
                    if (typeof _$offset === 'string') return _$offset.split(',').map(function(value) {
                        return Number.parseInt(value, 10);
                    });
                    if (typeof _$offset === 'function') return function(popperData) {
                        return _$offset(popperData, _this._element);
                    };
                    return _$offset;
                }
            },
            {
                key: "_resolvePossibleFunction",
                value: function _resolvePossibleFunction(arg) {
                    return execute(arg, [
                        this._element,
                        this._element
                    ]);
                }
            },
            {
                key: "_getPopperConfig",
                value: function _getPopperConfig(attachment) {
                    var _this = this;
                    var defaultBsPopperConfig = {
                        placement: attachment,
                        modifiers: [
                            {
                                name: 'flip',
                                options: {
                                    fallbackPlacements: this._config.fallbackPlacements
                                }
                            },
                            {
                                name: 'offset',
                                options: {
                                    offset: this._getOffset()
                                }
                            },
                            {
                                name: 'preventOverflow',
                                options: {
                                    boundary: this._config.boundary
                                }
                            },
                            {
                                name: 'arrow',
                                options: {
                                    element: ".".concat(this.constructor.NAME, "-arrow")
                                }
                            },
                            {
                                name: 'preSetPlacement',
                                enabled: true,
                                phase: 'beforeMain',
                                fn: function(data) {
                                    // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                                    // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                                    _this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                                }
                            }
                        ]
                    };
                    return (0, $9bf4d105a019f48b$export$71511d61b312f219)({}, defaultBsPopperConfig, execute(this._config.popperConfig, [
                        undefined,
                        defaultBsPopperConfig
                    ]));
                }
            },
            {
                key: "_setListeners",
                value: function _setListeners() {
                    var _this = this;
                    var triggers = this._config.trigger.split(' ');
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = triggers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var trigger = _step.value;
                            if (trigger === 'click') EventHandler.on(this._element, this.constructor.eventName(EVENT_CLICK$1), this._config.selector, function(event) {
                                var context = _this._initializeOnDelegatedTarget(event);
                                context._activeTrigger[TRIGGER_CLICK] = !(context._isShown() && context._activeTrigger[TRIGGER_CLICK]);
                                context.toggle();
                            });
                            else if (trigger !== TRIGGER_MANUAL) {
                                var eventIn = trigger === TRIGGER_HOVER ? this.constructor.eventName(EVENT_MOUSEENTER) : this.constructor.eventName(EVENT_FOCUSIN$1);
                                var eventOut = trigger === TRIGGER_HOVER ? this.constructor.eventName(EVENT_MOUSELEAVE) : this.constructor.eventName(EVENT_FOCUSOUT$1);
                                EventHandler.on(this._element, eventIn, this._config.selector, function(event) {
                                    var context = _this._initializeOnDelegatedTarget(event);
                                    context._activeTrigger[event.type === 'focusin' ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
                                    context._enter();
                                });
                                EventHandler.on(this._element, eventOut, this._config.selector, function(event) {
                                    var context = _this._initializeOnDelegatedTarget(event);
                                    context._activeTrigger[event.type === 'focusout' ? TRIGGER_FOCUS : TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                                    context._leave();
                                });
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this._hideModalHandler = function() {
                        if (_this._element) _this.hide();
                    };
                    EventHandler.on(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);
                }
            },
            {
                key: "_fixTitle",
                value: function _fixTitle() {
                    var title = this._element.getAttribute('title');
                    if (!title) return;
                    if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
                    this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
                    this._element.removeAttribute('title');
                }
            },
            {
                key: "_enter",
                value: function _enter() {
                    var _this = this;
                    if (this._isShown() || this._isHovered) {
                        this._isHovered = true;
                        return;
                    }
                    this._isHovered = true;
                    this._setTimeout(function() {
                        if (_this._isHovered) _this.show();
                    }, this._config.delay.show);
                }
            },
            {
                key: "_leave",
                value: function _leave() {
                    var _this = this;
                    if (this._isWithActiveTrigger()) return;
                    this._isHovered = false;
                    this._setTimeout(function() {
                        if (!_this._isHovered) _this.hide();
                    }, this._config.delay.hide);
                }
            },
            {
                key: "_setTimeout",
                value: function _setTimeout(handler, timeout) {
                    clearTimeout(this._timeout);
                    this._timeout = setTimeout(handler, timeout);
                }
            },
            {
                key: "_isWithActiveTrigger",
                value: function _isWithActiveTrigger() {
                    return Object.values(this._activeTrigger).includes(true);
                }
            },
            {
                key: "_getConfig",
                value: function _getConfig(config) {
                    var dataAttributes = Manipulator.getDataAttributes(this._element);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.keys(dataAttributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var dataAttribute = _step.value;
                            if (DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    config = (0, $9bf4d105a019f48b$export$71511d61b312f219)({}, dataAttributes, (typeof config === "undefined" ? "undefined" : (0, $f4bb2077aa61b74c$export$71511d61b312f219)(config)) === 'object' && config ? config : {});
                    config = this._mergeConfigObj(config);
                    config = this._configAfterMerge(config);
                    this._typeCheckConfig(config);
                    return config;
                }
            },
            {
                key: "_configAfterMerge",
                value: function _configAfterMerge(config) {
                    config.container = config.container === false ? document.body : getElement(config.container);
                    if (typeof config.delay === 'number') config.delay = {
                        show: config.delay,
                        hide: config.delay
                    };
                    if (typeof config.title === 'number') config.title = config.title.toString();
                    if (typeof config.content === 'number') config.content = config.content.toString();
                    return config;
                }
            },
            {
                key: "_getDelegateConfig",
                value: function _getDelegateConfig() {
                    var config = {};
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(this._config)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $91a007218046315e$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                            if (this.constructor.Default[key] !== value) config[key] = value;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    config.selector = false;
                    config.trigger = 'manual';
                    // In the future can be replaced with:
                    // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
                    // `Object.fromEntries(keysWithDifferentValues)`
                    return config;
                }
            },
            {
                key: "_disposePopper",
                value: function _disposePopper() {
                    if (this._popper) {
                        this._popper.destroy();
                        this._popper = null;
                    }
                    if (this.tip) {
                        this.tip.remove();
                        this.tip = null;
                    }
                }
            }
        ], [
            {
                key: "Default",
                get: // Getters
                function get() {
                    return Default$3;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$3;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$4;
                }
            },
            {
                key: "jQueryInterface",
                value: // Static
                function jQueryInterface(config) {
                    return this.each(function() {
                        var data = Tooltip.getOrCreateInstance(this, config);
                        if (typeof config !== 'string') return;
                        if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    });
                }
            }
        ]);
        return Tooltip;
    }(BaseComponent);
    /**
   * jQuery
   */ defineJQueryPlugin(Tooltip);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap popover.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var NAME$3 = 'popover';
    var SELECTOR_TITLE = '.popover-header';
    var SELECTOR_CONTENT = '.popover-body';
    var Default$2 = (0, $92079f442e5d1061$export$71511d61b312f219)((0, $9bf4d105a019f48b$export$71511d61b312f219)({}, Tooltip.Default), {
        content: '',
        offset: [
            0,
            8
        ],
        placement: 'right',
        template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
        trigger: 'click'
    });
    var DefaultType$2 = (0, $92079f442e5d1061$export$71511d61b312f219)((0, $9bf4d105a019f48b$export$71511d61b312f219)({}, Tooltip.DefaultType), {
        content: '(null|string|element|function)'
    });
    /**
   * Class definition
   */ var Popover = /*#__PURE__*/ function(Tooltip) {
        (0, $99c2e1b2c4a01e52$export$71511d61b312f219)(Popover, Tooltip);
        function Popover() {
            (0, $369e92947825c2b5$export$71511d61b312f219)(this, Popover);
            return (0, $972025e4d4e45634$export$71511d61b312f219)(this, Popover, arguments);
        }
        (0, $11b219ef186b1c94$export$71511d61b312f219)(Popover, [
            {
                // Overrides
                key: "_isWithContent",
                value: function _isWithContent() {
                    return this._getTitle() || this._getContent();
                }
            },
            {
                // Private
                key: "_getContentForTemplate",
                value: function _getContentForTemplate() {
                    var _obj;
                    return _obj = {}, (0, $28557b013f37bb6b$export$71511d61b312f219)(_obj, SELECTOR_TITLE, this._getTitle()), (0, $28557b013f37bb6b$export$71511d61b312f219)(_obj, SELECTOR_CONTENT, this._getContent()), _obj;
                }
            },
            {
                key: "_getContent",
                value: function _getContent() {
                    return this._resolvePossibleFunction(this._config.content);
                }
            }
        ], [
            {
                key: "Default",
                get: // Getters
                function get() {
                    return Default$2;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$2;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$3;
                }
            },
            {
                key: "jQueryInterface",
                value: // Static
                function jQueryInterface(config) {
                    return this.each(function() {
                        var data = Popover.getOrCreateInstance(this, config);
                        if (typeof config !== 'string') return;
                        if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    });
                }
            }
        ]);
        return Popover;
    }(Tooltip);
    /**
   * jQuery
   */ defineJQueryPlugin(Popover);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap scrollspy.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var NAME$2 = 'scrollspy';
    var DATA_KEY$2 = 'bs.scrollspy';
    var EVENT_KEY$2 = ".".concat(DATA_KEY$2);
    var DATA_API_KEY = '.data-api';
    var EVENT_ACTIVATE = "activate".concat(EVENT_KEY$2);
    var EVENT_CLICK = "click".concat(EVENT_KEY$2);
    var EVENT_LOAD_DATA_API$1 = "load".concat(EVENT_KEY$2).concat(DATA_API_KEY);
    var CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
    var CLASS_NAME_ACTIVE$1 = 'active';
    var SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
    var SELECTOR_TARGET_LINKS = '[href]';
    var SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
    var SELECTOR_NAV_LINKS = '.nav-link';
    var SELECTOR_NAV_ITEMS = '.nav-item';
    var SELECTOR_LIST_ITEMS = '.list-group-item';
    var SELECTOR_LINK_ITEMS = "".concat(SELECTOR_NAV_LINKS, ", ").concat(SELECTOR_NAV_ITEMS, " > ").concat(SELECTOR_NAV_LINKS, ", ").concat(SELECTOR_LIST_ITEMS);
    var SELECTOR_DROPDOWN = '.dropdown';
    var SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
    var Default$1 = {
        offset: null,
        // TODO: v6 @deprecated, keep it for backwards compatibility reasons
        rootMargin: '0px 0px -25%',
        smoothScroll: false,
        target: null,
        threshold: [
            0.1,
            0.5,
            1
        ]
    };
    var DefaultType$1 = {
        offset: '(number|null)',
        // TODO v6 @deprecated, keep it for backwards compatibility reasons
        rootMargin: 'string',
        smoothScroll: 'boolean',
        target: 'element',
        threshold: 'array'
    };
    /**
   * Class definition
   */ var ScrollSpy = /*#__PURE__*/ function(BaseComponent) {
        (0, $99c2e1b2c4a01e52$export$71511d61b312f219)(ScrollSpy, BaseComponent);
        function ScrollSpy(element, config) {
            (0, $369e92947825c2b5$export$71511d61b312f219)(this, ScrollSpy);
            var _this;
            _this = (0, $972025e4d4e45634$export$71511d61b312f219)(this, ScrollSpy, [
                element,
                config
            ]);
            // this._element is the observablesContainer and config.target the menu links wrapper
            _this._targetLinks = new Map();
            _this._observableSections = new Map();
            _this._rootElement = getComputedStyle(_this._element).overflowY === 'visible' ? null : _this._element;
            _this._activeTarget = null;
            _this._observer = null;
            _this._previousScrollData = {
                visibleEntryTop: 0,
                parentScrollTop: 0
            };
            _this.refresh(); // initialize
            return _this;
        }
        (0, $11b219ef186b1c94$export$71511d61b312f219)(ScrollSpy, [
            {
                // Public
                key: "refresh",
                value: function refresh() {
                    this._initializeTargetsAndObservables();
                    this._maybeEnableSmoothScroll();
                    if (this._observer) this._observer.disconnect();
                    else this._observer = this._getNewObserver();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this._observableSections.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var section = _step.value;
                            this._observer.observe(section);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    this._observer.disconnect();
                    (0, $00e9f136d8b86c33$export$71511d61b312f219)((0, $81c9c858187986cb$export$71511d61b312f219)(ScrollSpy.prototype), "dispose", this).call(this);
                }
            },
            {
                // Private
                key: "_configAfterMerge",
                value: function _configAfterMerge(config) {
                    // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
                    config.target = getElement(config.target) || document.body;
                    // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
                    config.rootMargin = config.offset ? "".concat(config.offset, "px 0px -30%") : config.rootMargin;
                    if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map(function(value) {
                        return Number.parseFloat(value);
                    });
                    return config;
                }
            },
            {
                key: "_maybeEnableSmoothScroll",
                value: function _maybeEnableSmoothScroll() {
                    var _this = this;
                    if (!this._config.smoothScroll) return;
                    // unregister any previous listeners
                    EventHandler.off(this._config.target, EVENT_CLICK);
                    EventHandler.on(this._config.target, EVENT_CLICK, SELECTOR_TARGET_LINKS, function(event) {
                        var observableSection = _this._observableSections.get(event.target.hash);
                        if (observableSection) {
                            event.preventDefault();
                            var root = _this._rootElement || window;
                            var height = observableSection.offsetTop - _this._element.offsetTop;
                            if (root.scrollTo) {
                                root.scrollTo({
                                    top: height,
                                    behavior: 'smooth'
                                });
                                return;
                            }
                            // Chrome 60 doesn't support `scrollTo`
                            root.scrollTop = height;
                        }
                    });
                }
            },
            {
                key: "_getNewObserver",
                value: function _getNewObserver() {
                    var _this = this;
                    var options = {
                        root: this._rootElement,
                        threshold: this._config.threshold,
                        rootMargin: this._config.rootMargin
                    };
                    return new IntersectionObserver(function(entries) {
                        return _this._observerCallback(entries);
                    }, options);
                }
            },
            {
                // The logic of selection
                key: "_observerCallback",
                value: function _observerCallback(entries) {
                    var _this = this;
                    var targetElement = function(entry) {
                        return _this._targetLinks.get("#".concat(entry.target.id));
                    };
                    var activate = function(entry) {
                        _this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
                        _this._process(targetElement(entry));
                    };
                    var parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
                    var userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
                    this._previousScrollData.parentScrollTop = parentScrollTop;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var entry = _step.value;
                            if (!entry.isIntersecting) {
                                this._activeTarget = null;
                                this._clearActiveClass(targetElement(entry));
                                continue;
                            }
                            var entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
                            // if we are scrolling down, pick the bigger offsetTop
                            if (userScrollsDown && entryIsLowerThanPrevious) {
                                activate(entry);
                                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                                if (!parentScrollTop) return;
                                continue;
                            }
                            // if we are scrolling up, pick the smallest offsetTop
                            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "_initializeTargetsAndObservables",
                value: function _initializeTargetsAndObservables() {
                    this._targetLinks = new Map();
                    this._observableSections = new Map();
                    var targetLinks = SelectorEngine.find(SELECTOR_TARGET_LINKS, this._config.target);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = targetLinks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var anchor = _step.value;
                            // ensure that the anchor has an id and is not disabled
                            if (!anchor.hash || isDisabled(anchor)) continue;
                            var observableSection = SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
                            // ensure that the observableSection exists & is visible
                            if (isVisible(observableSection)) {
                                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                                this._observableSections.set(anchor.hash, observableSection);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "_process",
                value: function _process(target) {
                    if (this._activeTarget === target) return;
                    this._clearActiveClass(this._config.target);
                    this._activeTarget = target;
                    target.classList.add(CLASS_NAME_ACTIVE$1);
                    this._activateParents(target);
                    EventHandler.trigger(this._element, EVENT_ACTIVATE, {
                        relatedTarget: target
                    });
                }
            },
            {
                key: "_activateParents",
                value: function _activateParents(target) {
                    // Activate dropdown parents
                    if (target.classList.contains(CLASS_NAME_DROPDOWN_ITEM)) {
                        SelectorEngine.findOne(SELECTOR_DROPDOWN_TOGGLE$1, target.closest(SELECTOR_DROPDOWN)).classList.add(CLASS_NAME_ACTIVE$1);
                        return;
                    }
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator = SelectorEngine.parents(target, SELECTOR_NAV_LIST_GROUP)[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                            var listGroup = _step.value;
                            try {
                                // Set triggered links parents as active
                                // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
                                for(var _iterator1 = SelectorEngine.prev(listGroup, SELECTOR_LINK_ITEMS)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                    var item = _step1.value;
                                    item.classList.add(CLASS_NAME_ACTIVE$1);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            },
            {
                key: "_clearActiveClass",
                value: function _clearActiveClass(parent) {
                    parent.classList.remove(CLASS_NAME_ACTIVE$1);
                    var activeNodes = SelectorEngine.find("".concat(SELECTOR_TARGET_LINKS, ".").concat(CLASS_NAME_ACTIVE$1), parent);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = activeNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var node = _step.value;
                            node.classList.remove(CLASS_NAME_ACTIVE$1);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        ], [
            {
                key: "Default",
                get: // Getters
                function get() {
                    return Default$1;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$1;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$2;
                }
            },
            {
                key: "jQueryInterface",
                value: // Static
                function jQueryInterface(config) {
                    return this.each(function() {
                        var data = ScrollSpy.getOrCreateInstance(this, config);
                        if (typeof config !== 'string') return;
                        if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    });
                }
            }
        ]);
        return ScrollSpy;
    }(BaseComponent);
    /**
   * Data API implementation
   */ EventHandler.on(window, EVENT_LOAD_DATA_API$1, function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = SelectorEngine.find(SELECTOR_DATA_SPY)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var spy = _step.value;
                ScrollSpy.getOrCreateInstance(spy);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    /**
   * jQuery
   */ defineJQueryPlugin(ScrollSpy);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap tab.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var NAME$1 = 'tab';
    var DATA_KEY$1 = 'bs.tab';
    var EVENT_KEY$1 = ".".concat(DATA_KEY$1);
    var EVENT_HIDE$1 = "hide".concat(EVENT_KEY$1);
    var EVENT_HIDDEN$1 = "hidden".concat(EVENT_KEY$1);
    var EVENT_SHOW$1 = "show".concat(EVENT_KEY$1);
    var EVENT_SHOWN$1 = "shown".concat(EVENT_KEY$1);
    var EVENT_CLICK_DATA_API = "click".concat(EVENT_KEY$1);
    var EVENT_KEYDOWN = "keydown".concat(EVENT_KEY$1);
    var EVENT_LOAD_DATA_API = "load".concat(EVENT_KEY$1);
    var ARROW_LEFT_KEY = 'ArrowLeft';
    var ARROW_RIGHT_KEY = 'ArrowRight';
    var ARROW_UP_KEY = 'ArrowUp';
    var ARROW_DOWN_KEY = 'ArrowDown';
    var HOME_KEY = 'Home';
    var END_KEY = 'End';
    var CLASS_NAME_ACTIVE = 'active';
    var CLASS_NAME_FADE$1 = 'fade';
    var CLASS_NAME_SHOW$1 = 'show';
    var CLASS_DROPDOWN = 'dropdown';
    var SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
    var SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
    var NOT_SELECTOR_DROPDOWN_TOGGLE = ":not(".concat(SELECTOR_DROPDOWN_TOGGLE, ")");
    var SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
    var SELECTOR_OUTER = '.nav-item, .list-group-item';
    var SELECTOR_INNER = ".nav-link".concat(NOT_SELECTOR_DROPDOWN_TOGGLE, ", .list-group-item").concat(NOT_SELECTOR_DROPDOWN_TOGGLE, ', [role="tab"]').concat(NOT_SELECTOR_DROPDOWN_TOGGLE);
    var SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
    var SELECTOR_INNER_ELEM = "".concat(SELECTOR_INNER, ", ").concat(SELECTOR_DATA_TOGGLE);
    var SELECTOR_DATA_TOGGLE_ACTIVE = ".".concat(CLASS_NAME_ACTIVE, '[data-bs-toggle="tab"], .').concat(CLASS_NAME_ACTIVE, '[data-bs-toggle="pill"], .').concat(CLASS_NAME_ACTIVE, '[data-bs-toggle="list"]');
    /**
   * Class definition
   */ var Tab = /*#__PURE__*/ function(BaseComponent) {
        (0, $99c2e1b2c4a01e52$export$71511d61b312f219)(Tab, BaseComponent);
        function Tab(element) {
            (0, $369e92947825c2b5$export$71511d61b312f219)(this, Tab);
            var _this;
            _this = (0, $972025e4d4e45634$export$71511d61b312f219)(this, Tab, [
                element
            ]);
            _this._parent = _this._element.closest(SELECTOR_TAB_PANEL);
            if (!_this._parent) return (0, $2d772972bd4fe337$export$71511d61b312f219)(_this);
            // Set up initial aria attributes
            _this._setInitialAttributes(_this._parent, _this._getChildren());
            EventHandler.on(_this._element, EVENT_KEYDOWN, function(event) {
                return _this._keydown(event);
            });
            return _this;
        }
        (0, $11b219ef186b1c94$export$71511d61b312f219)(Tab, [
            {
                // Public
                key: "show",
                value: function show() {
                    // Shows this elem and deactivate the active sibling if exists
                    var innerElem = this._element;
                    if (this._elemIsActive(innerElem)) return;
                    // Search for active tab on same parent to deactivate it
                    var active = this._getActiveElem();
                    var hideEvent = active ? EventHandler.trigger(active, EVENT_HIDE$1, {
                        relatedTarget: innerElem
                    }) : null;
                    var showEvent = EventHandler.trigger(innerElem, EVENT_SHOW$1, {
                        relatedTarget: active
                    });
                    if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
                    this._deactivate(active, innerElem);
                    this._activate(innerElem, active);
                }
            },
            {
                // Private
                key: "_activate",
                value: function _activate(element, relatedElem) {
                    var _this = this;
                    if (!element) return;
                    element.classList.add(CLASS_NAME_ACTIVE);
                    this._activate(SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
                    var complete = function() {
                        if (element.getAttribute('role') !== 'tab') {
                            element.classList.add(CLASS_NAME_SHOW$1);
                            return;
                        }
                        element.removeAttribute('tabindex');
                        element.setAttribute('aria-selected', true);
                        _this._toggleDropDown(element, true);
                        EventHandler.trigger(element, EVENT_SHOWN$1, {
                            relatedTarget: relatedElem
                        });
                    };
                    this._queueCallback(complete, element, element.classList.contains(CLASS_NAME_FADE$1));
                }
            },
            {
                key: "_deactivate",
                value: function _deactivate(element, relatedElem) {
                    var _this = this;
                    if (!element) return;
                    element.classList.remove(CLASS_NAME_ACTIVE);
                    element.blur();
                    this._deactivate(SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
                    var complete = function() {
                        if (element.getAttribute('role') !== 'tab') {
                            element.classList.remove(CLASS_NAME_SHOW$1);
                            return;
                        }
                        element.setAttribute('aria-selected', false);
                        element.setAttribute('tabindex', '-1');
                        _this._toggleDropDown(element, false);
                        EventHandler.trigger(element, EVENT_HIDDEN$1, {
                            relatedTarget: relatedElem
                        });
                    };
                    this._queueCallback(complete, element, element.classList.contains(CLASS_NAME_FADE$1));
                }
            },
            {
                key: "_keydown",
                value: function _keydown(event) {
                    if (![
                        ARROW_LEFT_KEY,
                        ARROW_RIGHT_KEY,
                        ARROW_UP_KEY,
                        ARROW_DOWN_KEY,
                        HOME_KEY,
                        END_KEY
                    ].includes(event.key)) return;
                    event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
                    event.preventDefault();
                    var children = this._getChildren().filter(function(element) {
                        return !isDisabled(element);
                    });
                    var nextActiveElement;
                    if ([
                        HOME_KEY,
                        END_KEY
                    ].includes(event.key)) nextActiveElement = children[event.key === HOME_KEY ? 0 : children.length - 1];
                    else {
                        var isNext = [
                            ARROW_RIGHT_KEY,
                            ARROW_DOWN_KEY
                        ].includes(event.key);
                        nextActiveElement = getNextActiveElement(children, event.target, isNext, true);
                    }
                    if (nextActiveElement) {
                        nextActiveElement.focus({
                            preventScroll: true
                        });
                        Tab.getOrCreateInstance(nextActiveElement).show();
                    }
                }
            },
            {
                key: "_getChildren",
                value: function _getChildren() {
                    // collection of inner elements
                    return SelectorEngine.find(SELECTOR_INNER_ELEM, this._parent);
                }
            },
            {
                key: "_getActiveElem",
                value: function _getActiveElem() {
                    var _this = this;
                    return this._getChildren().find(function(child) {
                        return _this._elemIsActive(child);
                    }) || null;
                }
            },
            {
                key: "_setInitialAttributes",
                value: function _setInitialAttributes(parent, children) {
                    this._setAttributeIfNotExists(parent, 'role', 'tablist');
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var child = _step.value;
                            this._setInitialAttributesOnChild(child);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "_setInitialAttributesOnChild",
                value: function _setInitialAttributesOnChild(child) {
                    child = this._getInnerElement(child);
                    var isActive = this._elemIsActive(child);
                    var outerElem = this._getOuterElement(child);
                    child.setAttribute('aria-selected', isActive);
                    if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
                    if (!isActive) child.setAttribute('tabindex', '-1');
                    this._setAttributeIfNotExists(child, 'role', 'tab');
                    // set attributes to the related panel too
                    this._setInitialAttributesOnTargetPanel(child);
                }
            },
            {
                key: "_setInitialAttributesOnTargetPanel",
                value: function _setInitialAttributesOnTargetPanel(child) {
                    var target = SelectorEngine.getElementFromSelector(child);
                    if (!target) return;
                    this._setAttributeIfNotExists(target, 'role', 'tabpanel');
                    if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', "".concat(child.id));
                }
            },
            {
                key: "_toggleDropDown",
                value: function _toggleDropDown(element, open) {
                    var outerElem = this._getOuterElement(element);
                    if (!outerElem.classList.contains(CLASS_DROPDOWN)) return;
                    var toggle = function(selector, className) {
                        var _$element = SelectorEngine.findOne(selector, outerElem);
                        if (_$element) _$element.classList.toggle(className, open);
                    };
                    toggle(SELECTOR_DROPDOWN_TOGGLE, CLASS_NAME_ACTIVE);
                    toggle(SELECTOR_DROPDOWN_MENU, CLASS_NAME_SHOW$1);
                    outerElem.setAttribute('aria-expanded', open);
                }
            },
            {
                key: "_setAttributeIfNotExists",
                value: function _setAttributeIfNotExists(element, attribute, value) {
                    if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
                }
            },
            {
                key: "_elemIsActive",
                value: function _elemIsActive(elem) {
                    return elem.classList.contains(CLASS_NAME_ACTIVE);
                }
            },
            {
                // Try to get the inner element (usually the .nav-link)
                key: "_getInnerElement",
                value: function _getInnerElement(elem) {
                    return elem.matches(SELECTOR_INNER_ELEM) ? elem : SelectorEngine.findOne(SELECTOR_INNER_ELEM, elem);
                }
            },
            {
                // Try to get the outer element (usually the .nav-item)
                key: "_getOuterElement",
                value: function _getOuterElement(elem) {
                    return elem.closest(SELECTOR_OUTER) || elem;
                }
            }
        ], [
            {
                key: "NAME",
                get: // Getters
                function get() {
                    return NAME$1;
                }
            },
            {
                key: "jQueryInterface",
                value: // Static
                function jQueryInterface(config) {
                    return this.each(function() {
                        var data = Tab.getOrCreateInstance(this);
                        if (typeof config !== 'string') return;
                        if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    });
                }
            }
        ]);
        return Tab;
    }(BaseComponent);
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if (isDisabled(this)) return;
        Tab.getOrCreateInstance(this).show();
    });
    /**
   * Initialize on focus
   */ EventHandler.on(window, EVENT_LOAD_DATA_API, function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = SelectorEngine.find(SELECTOR_DATA_TOGGLE_ACTIVE)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                Tab.getOrCreateInstance(element);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Tab);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap toast.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var NAME = 'toast';
    var DATA_KEY = 'bs.toast';
    var EVENT_KEY = ".".concat(DATA_KEY);
    var EVENT_MOUSEOVER = "mouseover".concat(EVENT_KEY);
    var EVENT_MOUSEOUT = "mouseout".concat(EVENT_KEY);
    var EVENT_FOCUSIN = "focusin".concat(EVENT_KEY);
    var EVENT_FOCUSOUT = "focusout".concat(EVENT_KEY);
    var EVENT_HIDE = "hide".concat(EVENT_KEY);
    var EVENT_HIDDEN = "hidden".concat(EVENT_KEY);
    var EVENT_SHOW = "show".concat(EVENT_KEY);
    var EVENT_SHOWN = "shown".concat(EVENT_KEY);
    var CLASS_NAME_FADE = 'fade';
    var CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
    var CLASS_NAME_SHOW = 'show';
    var CLASS_NAME_SHOWING = 'showing';
    var DefaultType = {
        animation: 'boolean',
        autohide: 'boolean',
        delay: 'number'
    };
    var Default = {
        animation: true,
        autohide: true,
        delay: 5000
    };
    /**
   * Class definition
   */ var Toast = /*#__PURE__*/ function(BaseComponent) {
        (0, $99c2e1b2c4a01e52$export$71511d61b312f219)(Toast, BaseComponent);
        function Toast(element, config) {
            (0, $369e92947825c2b5$export$71511d61b312f219)(this, Toast);
            var _this;
            _this = (0, $972025e4d4e45634$export$71511d61b312f219)(this, Toast, [
                element,
                config
            ]);
            _this._timeout = null;
            _this._hasMouseInteraction = false;
            _this._hasKeyboardInteraction = false;
            _this._setListeners();
            return _this;
        }
        (0, $11b219ef186b1c94$export$71511d61b312f219)(Toast, [
            {
                // Public
                key: "show",
                value: function show() {
                    var _this = this;
                    var showEvent = EventHandler.trigger(this._element, EVENT_SHOW);
                    if (showEvent.defaultPrevented) return;
                    this._clearTimeout();
                    if (this._config.animation) this._element.classList.add(CLASS_NAME_FADE);
                    var complete = function() {
                        _this._element.classList.remove(CLASS_NAME_SHOWING);
                        EventHandler.trigger(_this._element, EVENT_SHOWN);
                        _this._maybeScheduleHide();
                    };
                    this._element.classList.remove(CLASS_NAME_HIDE); // @deprecated
                    reflow(this._element);
                    this._element.classList.add(CLASS_NAME_SHOW, CLASS_NAME_SHOWING);
                    this._queueCallback(complete, this._element, this._config.animation);
                }
            },
            {
                key: "hide",
                value: function hide() {
                    var _this = this;
                    if (!this.isShown()) return;
                    var hideEvent = EventHandler.trigger(this._element, EVENT_HIDE);
                    if (hideEvent.defaultPrevented) return;
                    var complete = function() {
                        _this._element.classList.add(CLASS_NAME_HIDE); // @deprecated
                        _this._element.classList.remove(CLASS_NAME_SHOWING, CLASS_NAME_SHOW);
                        EventHandler.trigger(_this._element, EVENT_HIDDEN);
                    };
                    this._element.classList.add(CLASS_NAME_SHOWING);
                    this._queueCallback(complete, this._element, this._config.animation);
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    this._clearTimeout();
                    if (this.isShown()) this._element.classList.remove(CLASS_NAME_SHOW);
                    (0, $00e9f136d8b86c33$export$71511d61b312f219)((0, $81c9c858187986cb$export$71511d61b312f219)(Toast.prototype), "dispose", this).call(this);
                }
            },
            {
                key: "isShown",
                value: function isShown() {
                    return this._element.classList.contains(CLASS_NAME_SHOW);
                }
            },
            {
                // Private
                key: "_maybeScheduleHide",
                value: function _maybeScheduleHide() {
                    var _this = this;
                    if (!this._config.autohide) return;
                    if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
                    this._timeout = setTimeout(function() {
                        _this.hide();
                    }, this._config.delay);
                }
            },
            {
                key: "_onInteraction",
                value: function _onInteraction(event, isInteracting) {
                    switch(event.type){
                        case 'mouseover':
                        case 'mouseout':
                            this._hasMouseInteraction = isInteracting;
                            break;
                        case 'focusin':
                        case 'focusout':
                            this._hasKeyboardInteraction = isInteracting;
                            break;
                    }
                    if (isInteracting) {
                        this._clearTimeout();
                        return;
                    }
                    var nextElement = event.relatedTarget;
                    if (this._element === nextElement || this._element.contains(nextElement)) return;
                    this._maybeScheduleHide();
                }
            },
            {
                key: "_setListeners",
                value: function _setListeners() {
                    var _this = this;
                    EventHandler.on(this._element, EVENT_MOUSEOVER, function(event) {
                        return _this._onInteraction(event, true);
                    });
                    EventHandler.on(this._element, EVENT_MOUSEOUT, function(event) {
                        return _this._onInteraction(event, false);
                    });
                    EventHandler.on(this._element, EVENT_FOCUSIN, function(event) {
                        return _this._onInteraction(event, true);
                    });
                    EventHandler.on(this._element, EVENT_FOCUSOUT, function(event) {
                        return _this._onInteraction(event, false);
                    });
                }
            },
            {
                key: "_clearTimeout",
                value: function _clearTimeout() {
                    clearTimeout(this._timeout);
                    this._timeout = null;
                }
            }
        ], [
            {
                key: "Default",
                get: // Getters
                function get() {
                    return Default;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME;
                }
            },
            {
                key: "jQueryInterface",
                value: // Static
                function jQueryInterface(config) {
                    return this.each(function() {
                        var data = Toast.getOrCreateInstance(this, config);
                        if (typeof config === 'string') {
                            if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                            data[config](this);
                        }
                    });
                }
            }
        ]);
        return Toast;
    }(BaseComponent);
    /**
   * Data API implementation
   */ enableDismissTrigger(Toast);
    /**
   * jQuery
   */ defineJQueryPlugin(Toast);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap index.umd.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ var index_umd = {
        Alert: Alert,
        Button: Button,
        Carousel: Carousel,
        Collapse: Collapse,
        Dropdown: Dropdown,
        Modal: Modal,
        Offcanvas: Offcanvas,
        Popover: Popover,
        ScrollSpy: ScrollSpy,
        Tab: Tab,
        Toast: Toast,
        Tooltip: Tooltip
    };
    return index_umd;
});


var $2fd56a16bb506186$exports = {};
var $2fd56a16bb506186$var$redark = {
    codeBlock: {
        backgroundColor: '#18181b'
    },
    colors: {
        error: {
            main: '#ef4444'
        },
        border: {
            light: '#27272a',
            dark: '#a1a1aa'
        },
        http: {
            basic: '#71717a',
            delete: '#ef4444',
            get: '#22c55e',
            head: '#d946ef',
            link: '#06b6d4',
            options: '#eab308',
            patch: '#f97316',
            post: '#3b82f6',
            put: '#ec4899'
        },
        primary: {
            main: '#71717a'
        },
        responses: {
            error: {
                backgroundColor: 'rgba(239,68,68,0.1)',
                borderColor: '#fca5a5',
                color: '#ef4444',
                tabTextColor: '#ef4444'
            },
            info: {
                backgroundColor: 'rgba(59,131,246,0.1)',
                borderColor: '#93c5fd',
                color: '#3b82f6',
                tabTextColor: '#3b82f6'
            },
            redirect: {
                backgroundColor: 'rgba(234,179,8,0.1)',
                borderColor: '#fde047',
                color: '#eab308',
                tabTextColor: '#eab308'
            },
            success: {
                backgroundColor: 'rgba(34,197,94,0.1)',
                borderColor: '#86efac',
                color: '#22c55e',
                tabTextColor: '#22c55e'
            },
            warning: {
                main: '#eab308'
            }
        },
        secondary: {
            main: '#3f3f46',
            light: '#27272a'
        },
        success: {
            main: '#22c55e'
        },
        text: {
            primary: '#fafafa',
            secondary: '#d4d4d8',
            light: '#3f3f46'
        }
    },
    fab: {
        backgroundColor: '#52525b',
        color: '#67e8f9'
    },
    rightPanel: {
        backgroundColor: '#27272a',
        servers: {
            overlay: {
                backgroundColor: '#27272a'
            },
            url: {
                backgroundColor: '#18181b'
            }
        }
    },
    schema: {
        linesColor: '#d8b4fe',
        typeNameColor: '#93c5fd',
        typeTitleColor: '#1d4ed8'
    },
    sidebar: {
        activeTextColor: '#ffffff',
        backgroundColor: '#18181b',
        textColor: '#a1a1aa'
    },
    typography: {
        code: {
            backgroundColor: '#18181b',
            color: '#fde047'
        },
        links: {
            color: '#0ea5e9',
            hover: '#0ea5e9',
            textDecoration: 'none',
            hoverTextDecoration: 'underline',
            visited: '#0ea5e9'
        }
    },
    extensionsHook: function(c) {
        if (c === 'UnderlinedHeader') return {
            color: '#a1a1aa',
            fontWeight: 'bold',
            borderBottom: '1px solid #3f3f46'
        };
    }
};
var $2fd56a16bb506186$var$themeAsString = "{\n  codeBlock: {\n    backgroundColor: '#18181b',\n  },\n  colors: {\n    error: {\n      main: '#ef4444',\n    },\n    border: {\n      light: '#27272a',\n      dark: '#a1a1aa',\n    },\n    http: {\n      basic: '#71717a',\n      delete: '#ef4444',\n      get: '#22c55e',\n      head: '#d946ef',\n      link: '#06b6d4',\n      options: '#eab308',\n      patch: '#f97316',\n      post: '#3b82f6',\n      put: '#ec4899',\n    },\n    primary: {\n      main: '#71717a',\n    },\n    responses: {\n      error: {\n        backgroundColor: 'rgba(239,68,68,0.1)',\n        borderColor: '#fca5a5',\n        color: '#ef4444',\n        tabTextColor: '#ef4444',\n      },\n      info: {\n        backgroundColor: 'rgba(59,131,246,0.1)',\n        borderColor: '#93c5fd',\n        color: '#3b82f6',\n        tabTextColor: '#3b82f6',\n      },\n      redirect: {\n        backgroundColor: 'rgba(234,179,8,0.1)',\n        borderColor: '#fde047',\n        color: '#eab308',\n        tabTextColor: '#eab308',\n      },\n      success: {\n        backgroundColor: 'rgba(34,197,94,0.1)',\n        borderColor: '#86efac',\n        color: '#22c55e',\n        tabTextColor: '#22c55e',\n      },\n      warning: {\n        main: '#eab308',\n      },\n    },\n    secondary: {\n      main: '#3f3f46',\n      light: '#27272a',\n    },\n    success: {\n      main: '#22c55e',\n    },\n    text: {\n      primary: '#fafafa',\n      secondary: '#d4d4d8',\n      light: '#3f3f46',\n    },\n  },\n  fab: {\n    backgroundColor: '#52525b',\n    color: '#67e8f9',\n  },\n  rightPanel: {\n    backgroundColor: '#27272a',\n    servers: {\n      overlay: {\n        backgroundColor: '#27272a',\n      },\n      url: {\n        backgroundColor: '#18181b',\n      },\n    },\n  },\n  schema: {\n    linesColor: '#d8b4fe',\n    typeNameColor: '#93c5fd',\n    typeTitleColor: '#1d4ed8',\n  },\n  sidebar: {\n    activeTextColor: '#ffffff',\n    backgroundColor: '#18181b',\n    textColor: '#a1a1aa',\n  },\n  typography: {\n    code: {\n      backgroundColor: '#18181b',\n      color: '#fde047',\n    },\n    links: {\n      color: '#0ea5e9',\n      hover: '#0ea5e9',\n      textDecoration: 'none',\n      hoverTextDecoration: 'underline',\n      visited: '#0ea5e9',\n    },\n  },\n  extensionsHook: (c) => {\n    if (c === 'UnderlinedHeader') {\n      return {\n        color: '#a1a1aa',\n        fontWeight: 'bold',\n        borderBottom: '1px solid #3f3f46',\n      };\n    }\n  },\n}";
if ($2fd56a16bb506186$exports) $2fd56a16bb506186$exports = {
    theme: $2fd56a16bb506186$var$redark,
    themeAsString: $2fd56a16bb506186$var$themeAsString
};


document.addEventListener("DOMContentLoaded", function() {
    var darkModeToggle = document.querySelector("#toggleMode");
    var prefersDarkMode = window.matchMedia("(prefers-color-scheme:dark)").matches;
    var currentTheme = localStorage.getItem("theme");
    if (currentTheme === "dark" || currentTheme === null && prefersDarkMode) {
        document.querySelector("#toggleMode").checked = true;
        setDark();
    } else {
        document.querySelector("#toggleMode").checked = false;
        setLight();
    }
    darkModeToggle.addEventListener("change", function() {
        var currentTheme = localStorage.getItem("theme");
        currentTheme === "light" ? setDark() : setLight();
    });
    function setDark() {
        Redoc.init(window.apiUrl, {
            theme: (0, (/*@__PURE__*/$parcel$interopDefault($2fd56a16bb506186$exports))).theme
        }, document.getElementById("redoc-content"));
        document.documentElement.classList.add("dark-theme");
        document.documentElement.classList.remove("light-theme");
        document.querySelector("#toggleMode").checked = true;
        document.documentElement.style.display = "block";
        localStorage.setItem("theme", "dark");
    }
    function setLight() {
        Redoc.init(window.apiUrl, {}, document.getElementById("redoc-content"));
        document.documentElement.classList.add("light-theme");
        document.documentElement.classList.remove("dark-theme");
        document.querySelector("#toggleMode").checked = false;
        document.documentElement.style.display = "block";
        localStorage.setItem("theme", "light");
    }
});


document.addEventListener("DOMContentLoaded", function() {
    var backToTopLink = document.querySelector(".scroll-to-top");
    window.direct.showToTop = function() {
        if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 300) backToTopLink.classList.add("show");
        else backToTopLink.classList.remove("show");
    };
    backToTopLink.addEventListener("click", function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
    window.onscroll = function() {
        if (document.querySelector(".in-page-sub-nav")) {
            var scrollPosInPageNav = window.direct.getPosition(document.querySelector(".in-page-sub-nav"));
            if (scrollPosInPageNav.y === 0) document.querySelector(".in-page-sub-nav").classList.add("remove-radius");
            else document.querySelector(".in-page-sub-nav").classList.remove("remove-radius");
        }
        window.direct.showToTop();
    };
});


window.direct = {};

})();
//# sourceMappingURL=default-apireference.js.map
